{
  "error": "Error",
  "try_again": "Versuchen Sie es noch einmal",
  "welcome": "herzlich willkommen",
  "version": "Version",
  "error_network_request_failed": "Verbindungsfehler",
  "error_check_internet": "Überprüfen Sie die Internetverbindung.",
  "login": "Anmeldung",
  "logout": "Abmelden",
  "cancel": "Stornieren",
  "ok": "OK",
  "yes": "Ja",
  "no": "Nein",
  "password": "Passwort",
  "e-mail": "E-Mail",
  "error_login_failed": "Anmeldung fehlgeschlagen",
  "skip": "überspringen",
  "error_no_connection_to_server": "Keine Verbindung zum Server.",
  "step": "Schritt",
  "not_available": "Nicht verfügbar",
  "draft": "Entwurf",
  "send": "Versenden",
  "scheduled": "Geplant",
  "message_draft": "Entwurf",
  "message_sent": "Gesendete",
  "message_success": "Erfolg",
  "message_paused": "Angehalten",
  "message_failed": "Fehlgeschlagen",
  "message_trash": "Müll",
  "message_scheduled": "Geplant",
  "success": "Erfolg",
  "close multiple recipients dialog": "Dialogfeld für mehrere Empfänger schließen",
  "open profile": "Profil öffnen",
  "schedule for later": "Zeitplan für später",
  "error_could_not_save_reservation": "Buchung sollte nicht gespeichert werden.",
  "error_problem_with_reservation": "Es gab ein Problem mit der Buchung.",
  "rent_now": "Jetzt mieten",
  "check_again": "Nochmal Überprüfen",
  "error_general_error": "Es ist ein Fehler aufgetreten!",
  "error_try_again": "Es ist ein Fehler aufgetreten, bitte erneut versuchen.",
  "No device token": "Nachricht konnte nicht gesendet werden, da der/die Empfänger entweder nicht eingeloggt ist/sind oder Benachrichtigungen abgelehnt hat.",
  "end": "Ende",
  "end_now": "Jetzt beenden",
  "hi": "Hi",
  "bye": "Ciao",
  "start_time": "Startzeit",
  "end_time": "Endzeit",
  "english": "Englisch",
  "german": "Deutsch",
  "loading": "Wird geladen",
  "created_date": "Erstelldatum",
  "created_at": "Erstellt am",
  "last_modified_at": "Zuletzt modifiziert am",
  "enter some contents in here": "Bitte geben Sie eine Nachricht ein...",
  "message_nbr": "Nachricht-Nr.",
  "send message": "Nachricht senden",
  "subject": "Betreff",
  "content": "Inhalt",
  "notification": "Hinweis",
  "to": "An",
  "enter a subject": "Geben Sie einen Betreff ein",
  "choose recipients...": "Empfänger auswählen...",
  "choose type of recipient": "Empfängertyp wählen",
  "choose type of notification": "Benachrichtigung auswählen",
  "userID": "Nutzer",
  "userGroup": "Benutzergruppe",
  "allUsers": "Alle Nutzer",
  "toast": "Toast Nachricht",
  "popup": "Pop-up Nachricht",
  "list of recipients must have at least 1 item": "Empfängerliste muss mindestens 1 Eintrag haben",
  "multiple": "Mehrere",
  "more": "Mehr",
  "user ${a} added to recipient field, please add another user": "Nutzer ${a} wurde zum Empfängerfeld hinzugefügt, bitte fügen Sie einen weiteren Nutzer hinzu.",
  "user group ${a} added to recipient field, please add another user group": "Benutzergruppe ${a} wurde zum Empfängerfeld hinzugefügt.",
  "user ${a} does not exist, please enter a valid user": "Nutzer ${a} existiert nicht, bitte geben Sie einen gültigen Benutzer ein.",
  "user group ${a} does not exist, please enter a valid user group": "Benutzergruppe ${a} existiert nicht, bitte geben Sie einen gültigen Benutzergruppe ein.",
  "subject of message is required": "Der Betreff der Nachricht ist erforderlich.",
  "type of recipient is required and must be one of the following values: userID, userGroup, allUsers": "Empfängertyp ist erforderlich und muss einer der folgenden Werte sein: Nutzer, Benutzergruppe, Alle.",
  "display of notification is required and must be one of the following values: toast, popup": "Die Benachrichtigungsanzeige ist erforderlich und muss einen der folgenden Werte haben: Toast, Popup.",
  "display": "Anzeige",
  "list of recipients is required": "Empfängerliste erforderlich",
  "content of message is required": "Inhalt der Nachricht ist erforderlich",
  "must be positive": "Muss positiv sein",
  "delete message successfully": "Nachricht erfolgreich gelöschet",
  "delete message unsuccessfully": "Nachricht löschen war nicht erfolgreich",
  "schedule recurrence must be one of the following values: day, week, month, year": "Zeitplanwiederholung muss einer der folgenden Werte sein: Tag, Woche, Monat, Jahr",
  "click to remove this recipient": "Klicken Sie hier, um diesen Empfänger zu entfernen",
  "remove": "Löschen",
  "dashboard": "Dashboard",
  "fleet": "Kontingente",
  "users": "Nutzer",
  "username": "Nutzername",
  "my_inbooma": "Mein Inbooma",
  "reservation": "Buchung",
  "orders": "Aufträge",
  "toggle_${a}_view": "${a}-Ansicht öffnen.",
  "list": "Liste",
  "calendar": "Kalender",
  "customer": "Nutzer",
  "contingent": "Kontingent",
  "order": "Auftrag",
  "repeat": "Wiederholen",
  "repeat every": "Wiederhole jeden",
  "week": "Woche",
  "month": "Monat",
  "year": "Jahr",
  "schedule send": "Zeitplan senden",
  "pick date & time": "Zeitplan Nachricht",
  "close schedule dialog": "Zeitplan-Dialog schließen",
  "notifications": "Benachrichtigungen",
  "sms": "Sms",
  "push": "Push",
  "id": "ID",
  "new_${a}": "Neue ${a}",
  "edit_${a}": "${a} bearbeiten",
  "send_${a}": "${a} schicken",
  "toggle_${a}": "Wechseln zu ${a}",
  "open_filter_menu": "Filtermenü öffnen",
  "confirmed": "Bestätigt",
  "name": "Name",
  "location": "Standort\n",
  "location_": "Standort",
  "description": "Beschreibung",
  "open": "Offen",
  "resource": "Ressource",
  "close_window": "Fenster schließen",
  "list_of_locations": "Liste der Standorte",
  "no_locations_yet": "Sie haben noch keine Standorte hinzugefügt.",
  "declined": "abgelehnt",
  "no_linked_reservations": "Keine verknüpften Buchungen",
  "linked_reservations": "Verknüpfte Buchungen",
  "edit": "Bearbeiten",
  "delete": "Löschen",
  "date": "Datum",
  "object": "Objekt",
  "object_type": "Objekt-Typ",
  "nights": "Nächte",
  "status": "Status",
  "price": "Preis",
  "staff": "Mitarbeiter",
  "all": "Alle",
  "upcoming": "Bevorstehend",
  "past": "Vergangen",
  "dates": "Termine",
  "valid_from": "von",
  "valid_to": "bis",
  "paystate": "Zahlstatus",
  "resourcetype": "Typ",
  "paid": "Bezahlt",
  "partly_paid": "Teilweise bezahlt",
  "unpaid": "Unbezahlt",
  "cancel_reservation": "Buchung stornieren",
  "back_to_overview": "Zurück zur Übersicht",
  "quick_actions": "Aktionen ausführen",
  "filter_by_role": "Nach Rolle filtern",
  "role": "Rolle",
  "role_admin": "Administrator",
  "role_booking-manager": "Buchungsmanager",
  "user": "Nutzer",
  "role_user": "Nutzer",
  "role_client": "Nutzer/Kunde",
  "role_superadmin": "Superadmin",
  "role_guide": "Guide",
  "role_mediator": "Vermittler",
  "role_garage-staff": "Werkstatt",
  "user_role": "Rolle des Nutzers",
  "user_sidebar_tip_box": "Richten Sie Rollen ein oder konfigurieren Sie bestehende, um sicherzustellen, dass Ihre Daten sicher bleiben.",
  "active": "Aktiv",
  "inactive": "Inaktiv",
  "defect": "Defekt",
  "save": "Speichern",
  "contingents": "Kontingente",
  "change_language": "Sprache wählen",
  "no_linked_resources": "Keine verlinkten Ressourcen",
  "linked_resources": "Verlinkte Ressourcen",
  "battery_condition": "Akku-Stand",
  "open_external_link": "Externen Link öffnen",
  "mac_adress": "Schloss ID",
  "vehicles_active": "Fahrzeug(e) buchbar",
  "contingent_name": "Name des Kontingents",
  "resources_amount": "Anzahl Ressourcen",
  "autogenerate_resources": "Ressourcen automatisch generieren?",
  "start": "Start",
  "add_${a}": "${a} hinzufügen",
  "contingent_label": "Bezeichner Kontingent",
  "linked_orders": "Aufträge",
  "manage_roles": "Rollen bearbeiten",
  "select_user_role": "Wähle Nutzerrolle",
  "user_title": "Anrede",
  "user_title_mr": "Herr",
  "user_title_mrs": "Frau",
  "user_title_mx": "Divers",
  "first_name": "Vorname",
  "last_name": "Nachname",
  "company": "Firma",
  "user_active": "Aktiv",
  "longitude": "Longitude",
  "latitude": "Latitude",
  "geofence": "Geofence (Umriss)",
  "order_nbr": "Auftrags-Nr.",
  "open_profile": "Profil öffnen",
  "appointment": "Termin",
  "appointments": "Termine",
  "adult": "Erwachsener",
  "adults": "Erwachsene",
  "child": "Kind",
  "children": "Kinder",
  "save_${a}": "${a} speichern",
  "total_price": "Gesamtpreis",
  "updated_${a}": "${a} aktualisiert",
  "user_info_after_save": "Wenn eine E-Mail angegeben wurde, schicken wir das temporäre Passwort an diese Adresse",
  "choose_existing_customer": "Wähle vorhandenen Nutzer/Kunden",
  "add_${a}_first": "Zunächst ${a} anlegen",
  "select_element": "Markiere Objekt",
  "send_feedback": "Feedback verschicken",
  "profile": "Profil",
  "reservations": "Buchungen",
  "selected_${a}": "${a} ausgewählt",
  "delete_${a}": "${a} löschen",
  "change_status_to": "Status ändern zu",
  "required": "benötigt",
  "reservation_status": "Buchungsstatus",
  "requested": "angefragt",
  "admin": "Administrator",
  "save_next_step": "Speichern & zum nächsten Schritt",
  "vehicle_inactive": "Fahrzeug(e) inaktiv",
  "monday": "Montag",
  "tuesday": "Dienstag",
  "wednesday": "Mittwoch",
  "thursday": "Donnerstag",
  "friday": "Freitag",
  "saturday": "Samstag",
  "sunday": "Sonntag",
  "january": "Januar",
  "february": "Februar",
  "march": "März",
  "april": "April",
  "may": "Mai",
  "june": "Juni",
  "july": "Juli",
  "august": "August",
  "september": "September",
  "october": "Oktober",
  "november": "November",
  "december": "Dezember",
  "event_title": "Veranstaltungstitel",
  "single_appointment": "Einzeltermin",
  "recurring_appointment": "Wiederkehrender Termin",
  "repeat_every_after": "Wiederhole alle",
  "week(s)": "Woche(n)",
  "month(s)": "Monat(e)",
  "year(s)": "Jahr(e)",
  "optional": "optional",
  "till": "bis",
  "really_remove": "Möchten Sie diese Aktion wirklich ausführen?",
  "recurring": "wiederkehrend",
  "reschedule_appointment": "Termin umplanen",
  "o_clock": "Uhr",
  "form_validation_error": "Validierungsfehler - bitte füllen Sie alle markierten Felder aus.",
  "request_error": "Serverproblem - bitte laden Sie die Seite neu oder probieren Sie es später erneut.",
  "filter_selected": "Filter ausgewählt",
  "prices": "Preise",
  "radius_in_meter": "Radius in m",
  "no_contingents_yet": "Keine Kontingente",
  "app_msg_page_not_found": "Seite nicht gefunden.",
  "app_msg_page_not_found_body": "Vielleicht möchten Sie <a href=\"#\" onclick=\"javascript:window.history.back();return false;\">einen Schritt zurück springen</a>?!",
  "app_msg_collection_empty": "Keine Daten vorhanden",
  "app_msg_collection_empty_body": " ",
  "app_msg_access_error": "Zugriff verweigert.",
  "app_msg_access_error_body": "Ihre Rolle reicht nicht aus, um auf diese Seite zu zugreifen.",
  "app_msg_error": "Verbindungsproblem.",
  "app_msg_error_body": "Bitte prüfen Sie ihre Internetverbindung oder probieren Sie, <a href=\"#\" onclick=\"javascript:window.location.reload();return false;\">diese Seite neu zu laden</a>.",
  "manager": "Manager",
  "role_manager": "Manager",
  "app_msg_orders_intro": "Aufträge & Buchungen",
  "app_msg_orders_intro_body": "In einem Auftrag können mehrere zusammenhängende Bestellungen eines Nutzers gesammelt werden. Dies ermöglicht übersichtlichere Rechnungen und Bezahlungen.",
  "app_msg_orders_intro_action": "<strong>Wählen Sie einen Nutzer/Kunden</strong> um zum nächsten Schritt zu gelangen. <a href=\"#\" class=\"hide close-callout\">Nicht wieder zeigen.</a>",
  "saved_${a}": "${a} gespeichert",
  "could_not_be_saved_${a}": "${a} konnte nicht gespeichert werden",
  "saved": "Eingespart",
  "stored": "Gespeichert",
  "autogenerate_resources_body": "Es werden buchbare Ressourcen für dieses Kontingent erstellt (empfohlen).",
  "participants_amount": "Anzahl Teilnehmer",
  "removed_${a}": "${a} gelöscht",
  "resource_secret": "Geheimcode",
  "action_logged_out": "Sie haben sich erfolgreich ausgeloggt.",
  "action_logged_out_expired_token": "Ihre Sitzung ist abgelaufen.",
  "customers": "Kunden",
  "created": "erstellt",
  "empty_locations_teaser_body": "Ein Standort kann mit mehreren Kontingenten verknüpft werden.",
  "locations": "Standorte",
  "max_${a}_pers": "max. ${a} Pers.",
  "select_${a}": "${a} auswählen",
  "reset_filter": "Filter zurücksetzen",
  "notes": "Notizen",
  "no_special_char_allowed": "Mind. 3 Zeichen; keine Sonder- und Leerzeichen",
  "reservation_error_missing_begin": "Der Startwert fehlt.",
  "reservation_error_missing_end": "Der Endwert fehlt.",
  "invalid_time_format": "Falsches Zeitformat",
  "reservation_error_start_bigger_than_end": "Das Enddatum muss hinter dem Startdatum liegen.",
  "app_msg_empty_order": "Es wurden noch keine Buchungen mit diesem Auftrag verknüpft.",
  "user_error_unique_username": "Dieser Nutzername ist bereits vorhanden.",
  "completed": "Abgeschlossen",
  "added_${a}": "${a} hinzugefügt",
  "app_msg_contingents_intro": "Kontingente & Ressourcen",
  "app_msg_contingents_intro_body": "Kontingente können Fahrzeuge, Termine oder andere, buchbare Entitäten mit einer maximalen Buchungsmenge sein. Sollte Ihr Inbooma-Tarif eine App beinhalten, können diese Zahlen in reale Ressourcen überführt und um Fahrzeug-ID, -name oder Zugriffscodes erweitert werden.",
  "app_msg_users_intro": "Kunden- & Mitarbeiter-Verwaltung",
  "app_msg_users_intro_body": "Jeder Ihrer Kunden kann in dieser Liste eingesehen und ggf. bearbeitet werden. Außerdem lassen sich neue Benutzer mit einer der Rollen <strong>Administrator, Manager oder Kunde/Nutzer</strong> anlegen.",
  "user_registration_mail_sent": "Eine Registrierungsmail wurde versendet.",
  "change_bookable_resources": "Buchbare Ressourcen anpassen",
  "number_total": "Gesamtanzahl",
  "number_active": "Buchbare Ressourcen",
  "action_welcome_successfully_registered": "Willkommen bei Inbooma! Ihr Accont wurde erfolgreich registriert.",
  "appointments_error_no_contingent": "Es wurde kein Kontingent des Typ's \"Termine\" gefunden. Jetzt anlegen?",
  "day_on": "am",
  "reservations_error_no_contingents": "Es wurden keine Kontingente gefunden. Möchten Sie jetzt eines anlegen?",
  "abort": "abbrechen",
  "reservation_ended_not_editable": "Buchungsstatus nicht änderbar, da Buchung bereits abgeschlossen.",
  "contingent_warning_too_less_total": "Achtung: Es wurden mehr Ressourcen angelegt als im Kontingent benannt. Bitte erhöhen Sie die Gesamtzahl durch Klick auf die untere, orangene Leiste.",
  "tour_in_progress": "Im Gange",
  "app_order_bike_tour_${a}": "Buchung via App (${a} x 1)",
  "user_title_family": "Familie",
  "user_title_company": "Firma",
  "order_successfully_executed": "Eine E-Mail mit der Auftragsbestätigung wurde an den Nutzer versendet.",
  "order_successfully_executed_no_mail": "Der Auftrag wurde bestätigt",
  "execute_order": "Auftrag bestätigen und versenden",
  "order_executed_at": "Auftragsbestätigung verschickt am",
  "user_error_unique_mail": "Diese E-Mail-Adresse wird bereits verwendet",
  "execute_order_body": "Auftrag wird bestätigt und E-Mail 'Buchungsbestätigung' wird versendet.",
  "submit_order_status": "Versenden",
  "submit_order_status_body": "Es wird eine E-Mail mit den Buchungsinformationen und dem aktuellen Status an den Nutzer und Manager versendet.",
  "order_status_successfully_submitted": "Eine E-Mail mit dem aktuellen Auftragsstatus wurde versendet.",
  "user_activcurrentTargete_body": "Inaktive Nutzer können sich nicht einloggen.",
  "create_ics": "ICS Datei",
  "create_ics_all_orders": "ICS Datei für alle Aufträge erstellen",
  "resource_not_configured_yet": "Ressource ist unkonfiguriert.",
  "location_error_geofence_number": "Das Geofence-Feld muss eine Zahl beinhalten.",
  "street": "Strasse",
  "house_nbr": "Hausnummer",
  "zip": "Postleitzahl",
  "city": "Ort",
  "phone_nbr": "Telefon",
  "repeat_password": "Passwort wiederholen",
  "register": "registrieren",
  "registration": "Registrierung",
  "deleted_resource": "Gelöschte Ressource",
  "pricetype": "Preistyp",
  "pricetypes": "Preistypen",
  "pricetariff": "Preistarif",
  "pricetariffs": "Preistarife",
  "price_standard": "Standard",
  "warning_prices_not_complete": "Achtung: Nicht für alle Wochentage wurde ein Preis hinterlegt. Trotzdem fortfahren?",
  "price_total": "Gesamtpreis",
  "reservation_error_no_pricetariffs_for_${a}": "Es wurden noch keine Preise für dieses Kontingent hinterlegt. <a href=\"/contingents/${a}/prices\">Tarife hinzufügen.</a>",
  "price_error_select_values_first": "Wählen Sie Kontingent, Start- und Endzeit um einen Preis zu generieren.",
  "price_error_fetch": "Verbindungsproblem. Bitte später erneut versuchen.",
  "price_error_no_prices_found_for_tariff": "Es konnten keine Preise für diesen Tarif gefunden werden.",
  "reschedule": "Uhrzeit ändern",
  "${a}_of_${b}_booked": "${a} von ${b} Plätzen gebucht",
  "calendars_info_text": "Ein Kalender dient dazu, ähnliche Kontingente des Typs \"Termine\" zu gruppieren. Nachdem Sie einen Kalender angelegt haben, können diesem Kontingente zugewiesen und Events angelegt werden.",
  "remove_contingent_from_calendar": "Kontingent aus Kalender entfernen",
  "calendars": "Kalender",
  "close_notification": "Benachrichtigung schließen",
  "prices_begin_info": "Beginn der Preissaison",
  "prices_end_info": "Ende der Preissaison",
  "locations_description_field_info": "z.B. \"Nahe S-Bahnhof\"",
  "price_default_info": "Dieses Feld muss befüllt werden, auch wenn sie Wochentags-abhängige Preise festlegen möchten.",
  "toggle_event_blocked": "Termin blocken / Blockierung aufheben",
  "confirm_set_blocking": "Möchten Sie den Termin an diesem Tag wirklich blocken?",
  "event_confirm_unset_blocking": "Soll die Blockierung des Termins an diesem Tag wirklich aufgehoben werden?",
  "event_set_blocking": "Der Termin wurde geblockt.",
  "event_removed_blocking": "Der Termin ist wieder buchbar.",
  "unset_reschedule": "Änderung zurückzsetzen",
  "success_saved_rescheduling": "Der Termin wurde bearbeitet.",
  "success_removed_rescheduling": "Der Termin wurde bearbeitet.",
  "select_appointment": "Wähle Termin",
  "person_s": "Person(en)",
  "C_6_fleet": "Kontingente",
  "error_events_found_no_calendar": "Sie haben noch keinen Kalender mit diesem Kontingent verknüpft. Möchten Sie jetzt die Verknüpfung anlegen?",
  "status_booking_process": "Im Gange",
  "max_pers_count": "Max. Personenanzahl",
  "max_pers_count_help": "Die Anzahl eventueller, bereits gebuchter Teilnehmer darf nicht überschritten werden.",
  "open_link": "Link öffnen",
  "dsgvo_accept_label": "Hiermit akzeptiere ich die Datenschutzerklärung",
  "cancelled": "Storniert",
  "inprogress": "Im Gange",
  "inprogress_ext": "Im Gange",
  "inprogress_RAB": "Fahrt Im Gange",
  "language": "Sprache",
  "payments": "Bezahlungen",
  "overview": "Übersicht",
  "finances": "Zahlungen & Rechnungen",
  "reference_id": "Referenz ID",
  "price_origin_${a}": "Herkunft der Zahlung: ${a}",
  "amount": "Betrag",
  "payment_amount": "Zahlungsbetrag",
  "account": "Bankkonto",
  "transactions": "Transaktionen",
  "we_charge_you_following_positions": "wir berechnen Ihnen folgende Positionen",
  "net": "netto",
  "gross": "brutto",
  "ust": "USt",
  "ust_sentence": "USt.-Satz",
  "complete": "Rechnungsbetrag",
  "invoice_nbr": "Rechnungs-Nr.",
  "gesamt": "gesamt",
  "check_payment": "als bezahlKontingente planen markieren",
  "print": "drucken",
  "times": "Gebuchte Zeiten",
  "includes": "inklusive",
  "mwst": "MwSt.",
  "invoice": "Rechnung",
  "invoice_for": "Rechnung für",
  "create_invoice": "Rechnung erstellen",
  "check_your_inbox": "Vielen Dank für Deine Registrierung.",
  "a_confirmation_mail_was_sended": "Es wurde eine E-Mail zur Bestätigung deiner Registrierung an die vorliegende E-Mail Adresse gesendet. Falls nicht, prüfe bitte Deinen Spamordner.",
  "welcome_to_inbooma": "Hallo",
  "email_has_been_confirmed": "Deine E-Mail-Adresse sowie die Registrierung deines Accounts wurden\nerfolgreich verifiziert. Du kannst dich nun mit deinem Benutzernamen und\ndeinem Passwort in der App anmelden.",
  "login_now": "Anmelden",
  "username_to_short": "Benutzername zu kurz!",
  "stay_logged_in": "Eingeloggt bleiben?",
  "reset_password": "Passwort zurücksetzen",
  "forgot_password": "Passwort ändern",
  "made_width": "Entwickelt mit",
  "mobile_app": "Mobile Anwendung",
  "please_enter_email": "Ihre inbooma Account E-Mail",
  "email_to_short": "E-Mail Addresse zu kurz!",
  "next_step": "Weiter",
  "password_to_short": "Passwort zu kurz!",
  "unknown_email_address": "Diese E-Mail Adresse ist uns nicht bekannt!",
  "please_check_email": "Bitte schauen Sie in Ihren E-Mail Postfach nach der Aktivierungsmail.",
  "back_to_login": "Zurück zum Login",
  "data_protection_agreement": "Datenschutzvereinbarung",
  "order_cancelled_success_transactions": "In dem nun stornierten Auftrag wurde bereits eine Zahlung gebucht. Diese wird nicht automatisch erstattet.",
  "order_cancelled_success": "Auftrag erfolgreich storniert.",
  "payout_form": "Auszahlung",
  "confirm_payout": "Auszahlung bestätigen",
  "payout_amount_help": "Bitte trennen Sie Beträge mit einem Punkt, z.B. 120.30",
  "booking_activity": "Buchungsaktivität",
  "${a}_days": "${a} days",
  "payment_account": "Bankkonto",
  "payment_accounts": "Bankkonten",
  "payment_accounts_form": "Bankkonto verknüpfen",
  "account_holder_name": "Kontoeigentümer",
  "account_iban_number": "IBAN",
  "account_iban_number_info": " ",
  "bank_code": "BIC",
  "bank_code_info": "optional",
  "cash": "bar",
  "credit_card": "Kreditkarte",
  "credit": "Kreditkarte",
  "sepa": "SEPA",
  "pending": "ausstehend",
  "payout": "ausgezahlt",
  "refund": "wiedererstattet",
  "minimum_${a}_chars_required": "Mind. ${a} Zeichen benötigt",
  "both_passwords_must_be_the_same": "Passwörter stimmen nicht überein",
  "change_password": "Passwort ändern",
  "user_register_page": "Registrierungsformular für Benutzer",
  "zip_code": "PLZ",
  "email": "E-Mail",
  "house_number": "Hausnummer",
  "notification_text": "Mit * gekennzeichnete Felder müssen befüllt werden",
  "agb_accept_label": "Hiermit akzeptiere ich die Nutzungsbedingungen",
  "invalid_username_password": "Falscher Nutzername oder Passwort",
  "contingent_location_help": "An den ausgewählten Standorten erfolgt die Abholung und Rückgabe der Ressourcen.",
  "contingent_placeholder": "z.B. E-Bikes Standardgröße",
  "location_of_checkin": "Abholstandort",
  "location_of_checkout": "Rückgabestandort",
  "resource_start_location": "Start-Abholstandort",
  "facilities": "Abstellanlagen",
  "facility": "Abstellanlage",
  "slot": "Ladestation",
  "error_code": "Meldung Code",
  "error_text": "Meldung Text",
  "facility_modified": "Letzte Änderung",
  "linked_slots": "Ladestationen",
  "no_linked_slots": "Keine Ladestationen",
  "closed": "Schloss geschlossen",
  "charging_quality": "Charging Quality",
  "participants_bookable": "Teilnehmer buchbar",
  "discount_in_percent": "Rabatt (in Prozent)",
  "location_yet_undefined": "Standort unbekannt",
  "pricediscounts": "Rabatte",
  "discount_type": "Rabattart",
  "valid": "Gültig",
  "user_discount": "Nutzer- bzw. Kundenrabatt",
  "client_discount": "Wiederbucherrabatt",
  "pricediscount": "Rabatt",
  "app_msg_pricediscounts_intro": "Rabatte",
  "app_msg_pricediscounts_intro_body": "Rabatte ermöglichen es Ihnen, Ihren Kunden verschiedene Preisabzüge zu gewähren.",
  "discount_amount": "Rabatthöhe (in €)",
  "user_discounts": "Kundenrabatte",
  "client_discounts": "Wiederbucherrabatte",
  "discount_percent": "Rabatthöhe (in %)",
  "combineable": "Kombinierbar",
  "count_units": "Anzahl",
  "booking_type": "Typ",
  "phone_number": "Telefon",
  "country": "Land",
  "number_discounts": "Gutscheine",
  "number_discount": "Gutschein",
  "discount_number": "Gutscheincode",
  "you_are_activated_after_registration": "Wir bitten um ein wenig Geduld, bis Deine Registrierung verifiziert und Dein Account freigeschaltet ist.",
  "cannot_remove_${a}": "${a} kann nicht gelöscht werden, da die erforderlichen Rechte fehlen.",
  "cannot_update_${a}_${b}": "Bei ${a} konnte die Rolle ${b} nicht gesetzt werden, da die erforderlichen Rechte fehlen.",
  "with_role_${r}": " mit der Rolle ${r} ",
  "number_slots": "Number of Charging Stations",
  "autogenerate_facility_slots": "Autogenerate Charging Stations Amount",
  "autogenerate_facilities_body": "Charging Stations will be generated according to the Amount field above",
  "make_payout": "Auszahlen",
  "title": "Anrede",
  "The provided value is invalid": "Der eingegebene Wert ist ungültig",
  "This value is already in use": "Dieser Wert wird bereits benutzt",
  "withdrawable_cash": "Auszahlbar",
  "transactions_of_${a}": "Gesamte Transaktionen im ${a}",
  "client_account": "Hauptkonto",
  "user_account": "personlichen Konto",
  "payment_type": "Bezahlmethode",
  "edit_profile": "Profil bearbeiten",
  "user_nbr": "Nutzer Nr.",
  "kunden_nbr": "Kunden Nr.",
  "logged_in_as": "Eingeloggt als",
  "username_${a}_role_${b}": "Nutzername: ${a}, Rolle: ${b}",
  "unselect_all_filter": "Alle Filter entfernen",
  "unselect_filter": "Filter entfernen",
  "contains_reservations_from": "Enthält Buchungen beginnend am",
  "contains_reservations_till": "Enthält Buchungen endend am",
  "my_account": "Finanzen & Rechnungen",
  "login_submit": "Anmelden",
  "open_order_${a}": "Auftrag ${a} öffnen",
  "domain_not_authorized": "Registrierung nicht möglich / Domain nicht authorisiert",
  "customer_removed": "Nutzer gelöscht",
  "price_from": "Ab",
  "load_more_title": "Klicken um weitere Inhalte zu laden",
  "load_more": "Mehr laden",
  "contingent_removed": "Kontingent entfernt",
  "payout_success": "Die Auszahlung war erfolgreich!",
  "payout_error_999": "Nicht genug Guthaben vorhanden.",
  "duplicate": "duplizieren",
  "duplicate_resource_info": "Ressource kopieren und dem Kontingent hinzufügen.",
  "duplicate_resource_success_${a}": "Eine neue Ressource (#${a}) wurde angelegt.",
  "order_empty_remove": "Es befinden noch keine Buchungen am Auftrag. Soll dieser verworfen werden?",
  "one_location_required": "Mind. ein Standort wird benötigt",
  "appointment_blocked_not_bookable": "[Geblockt; nicht buchbar]",
  "payment_account_save_error": "Fehlerhafte BIC oder IBAN",
  "Minimum eight characters, at least one uppercase letter, one lowercase letter and one number": "Mindestens 8 Zeichen, inkl. 1 Grossbuchstabe, ein Kleinbuchstabe und eine Zahl",
  "sort_by_${a}": "Nach ${a} sortieren",
  "calendar_initializing": "Kalender wird geladen...",
  "booking_time_differs": "Abweichende Abhol- oder Rückgabezeit",
  "begin_booking": "Abholzeit",
  "end_booking": "Rückgabezeit",
  "reservation_no_price": "Ohne Preis",
  "new_password": "Neues Passwort",
  "new_password_help": "Mind. 8 Zeichen, eine Zahl, ein Groß-, und Kleinbuchstabe",
  "new_password_confirm": "Passwort bestätigen",
  "new_password_submit": "Passwort ändern",
  "new_password_fill_out": "Beide Felder müssen ausgefüllt sein",
  "password_reset_identical": "Beide Felder müssen identisch sein",
  "password_reset_invalid": "Passwort muss den Vorgaben entsprechen",
  "new_password_success": "Passwort erfolgreich geändert!",
  "ordersForm": "Auftrag verwalten",
  "unknown_or_removed_user": "Unbekannter oder bereits gelöschter Nutzer",
  "succesfully_changed_password": "Passwort erfolgreich geändert!",
  "user_error_short_username": "Benutzername muss mindestens 3 und höchstens 50 Zeichen lang sein und darf keine Sonderzeichen enthalten.",
  "email_format_not_valid": "Bitte geben Sie eine gültige E-Mail Adresse ein",
  "tarif": "Tarif",
  "tarifpreis": "Tarifpreis",
  "rabatt": "Rabatt",
  "mietpreis": "Mietpreis",
  "units_available": "Einheit(en) gewählt",
  "add_unit": "Einheit hinzufügen",
  "no_discount_selected": "Kein Rabatt gewählt",
  "action_conflict_less_selected_than_before": "Es gehen möglicherweise bereits konfigurierte Preise verloren",
  "action_unset_whole_contingent": "Bereits konfigurierte Preise gehen verloren",
  "warning_no_contingent_unit_available": "Zu diesem Zeitpunkt sind keine Einheiten verfügbar",
  "${a}_contingents_added": "${a} Einheit(en) hinzugefügt",
  "${a}_contingents_deleted": "${a} Einheit(en) entfernt",
  "filter_by_contingent_name": "Nach Name suchen...",
  "notes_external": "Anmerkung Nutzer/Kunde",
  "notes_internal": "Interne Notiz",
  "user_state_updated": "Nutzerstatus aktualisiert.",
  "select_unselect_contingent": "Klicken um Kontingent auszuwählen / zurücksetzen",
  "opening_times_for": "Check-In Zeiten für",
  "no_opening_times": "Keine Check-In Zeiten eingetragen.",
  "form_validation_error_contingent_form": "Bitte wählen Sie Uhrzeit, Standorte und Kontingente.",
  "a_password_reset_mail_was_sended": "Es wurde eine E-Mail zum Passwort zurücksetzen an Deine E-Mail Adresse gesendet. Falls nicht, prüfe bitte Deinen Spamordner.",
  "account_yet_unconfigured": "Konto nicht hinterlegt",
  "warning_reservation_in_progress": "Achtung: Es sind noch ungespeicherte Buchungen geöffnet. Bitte zuerst speichern oder Buchung abbrechen.",
  "in_days": "in Tagen",
  "ruecktransport": "Rücktransport",
  "continue": "Weiter",
  "save_booking": "Auftrag erstellen",
  "loading_return_stations_progress": "Lade Rückgabestandort...",
  "no_return_station_found": "Kein Rückgabestandort gefunden",
  "de_DE": "Deutsch",
  "en_GB": "Englisch",
  "quick_form_step_1": "Buchungsdaten",
  "quick_form_step_2": "Nutzerdaten",
  "role_manager-location": "Standortmanager",
  "add_existing_user": "Vorhandenen Nutzer wählen",
  "add_existing_resource": "Vorhandenes Fahrzeug wählen",
  "add_existing_order": "Vorhandenen Auftrag wählen",
  "add_existing_facility": "Vorhandene Abstellanlage wählen",
  "before_editing": "Vor Editierung",
  "action_requires_booking_save": "Buchung speichern um Änderungen wirksam zu machen.",
  "location_list_manager": "Standort Standortmanager",
  "location_list_manager_help": "Nur benötigt wenn Rolle `Standortmanager` gewählt.",
  "username_or_mail": "E-Mail Adresse oder Benutzername",
  "fr_FR": "Französisch",
  "remove_booking_first_to_edit": "Um den Abholstandort zu ändern, bitte bestehende Buchung löschen und neue Buchung anlegen.",
  "Fahrzeuge": "Fahrzeuge",
  "Fahrzeug": "Fahrzeug",
  "Bikesharing": "Bikesharing",
  "Termine": "Termine",
  "reservation_unsaved": "Ungespeichert",
  "user_has_newsletter": "Newsletter",
  "user_privacy_accepted_yes": "Datenschutzerklärung akzeptiert am",
  "user_privacy_accepted_no": "Datenschutzerklärung noch nicht akzeptiert",
  "user_tos_accepted_yes": "Nutzungsbedingungen akzeptiert am",
  "user_tos_accepted_no": "Nutzungsbedingungen noch nicht akzeptiert",
  "user_customer_nbr": "Mitgliedsnummer",
  "valid_from_date": "Gültig ab/am",
  "add_empty_user": "Formular zurücksetzen",
  "no_contingents_available": "Keine Kontingente verfügbar.",
  "checkin_reservation": "Check-In",
  "checkout_reservation": "Check-Out",
  "checkin_search_placeholder": "Filtern nach Name, MAC-ID oder Betriebsnummer",
  "submit_checkin": "Check-In abschliessen",
  "submit_checkout": "Check-Out für alle Ressourcen durchführen",
  "checked_in_contingents": "Eingecheckte Kontingente",
  "checkin_add_elements_to_cart": "Wählen Sie Ressourcen aus der Liste, um Sie dem Check-In hinzuzufügen.",
  "checkin_submit_error_empty": "Bitte fügen Sie erst Ressourcen der Check-In-Liste hinzu.",
  "checkin_submit_success": "Alle gewählten Ressourcen wurden erfolgreich eingecheckt. Die Buchung ist nun im Gange.",
  "checkout_submit_success": "Alle gewählten Ressourcen wurden erfolgreich ausgecheckt. Die Buchung ist nun abgeschlossen.",
  "checkin_remove_from_selection": "Aus Check-In entfernen",
  "checkin_add_to_selection": "Ressource einchecken",
  "checkin_comment_placeholder": "Kommentar Abgabe",
  "checkout_comment_placeholder": "Kommentar Rücknahme",
  "external_resource_id": "Betriebsnummer (externe Ressource-ID)",
  "checkin_resources_total": "Zu wählen",
  "checkin_resources_selected": "Gewählt",
  "checked_in_at": "Eingecheckt am: ",
  "booking_able": "Buchbar",
  "voucher": "Gutschein",
  "vouchers": "Gutscheine",
  "voucher_type": "Gutscheinart",
  "voucherTypes": "Gutscheinarten",
  "voucher_types": "Gutscheinarten",
  "voucher_type_discount": "Rabatt",
  "voucher_type_gift_card": "Geschenkgutschein",
  "voucher_unit": "Einheit",
  "voucher_type_id": "Gutscheinart Nr.",
  "voucher_unit_percentage": "Prozent",
  "voucher_unit_fix_price": "Festpreis",
  "voucher_unit_contingent": "Kontingent",
  "voucher_value": "Wert",
  "voucher_value_is_nan": "Wert ist keine Zahl",
  "vouchersForm": "Gutscheinformular",
  "tab_discount": "Rabattgutscheine",
  "tab_gift_card": "Geschenkgutscheine",
  "multiple_use": "Mehrfach einlösbar",
  "discount_vouchers": "Rabattgutschein",
  "type": "Typ",
  "sellable": "Verkaufbar",
  "unknown_or_removed_voucher": "Unbekannt oder gelöscht",
  "voucher_codes": "Gutscheincodes",
  "voucher_codes_source": "Codes erstellen",
  "voucher_codes_enter_as_text": "Codes eingeben",
  "voucher_codes_upload_file": "Datei hochladen",
  "voucher_codes_generate": "Zufällig generieren",
  "voucher_codes_generate_count": "Anzahl Codes",
  "voucher_codes_already_exist_${a}": "Dieser Code wird bereits benutzt: ${a}",
  "codes_file": "Datei wählen",
  "select_xlsx_file": "XLS/XLSX/CSV file",
  "enter_codes_separate_by": "mit ; trennen",
  "code": "Code",
  "codes": "Codes",
  "no_voucher_type_selected": "-",
  "invalid_codes_${a}": "Ungültiger Code: ${a}",
  "voucher_type_valid_to": "Gültig bis",
  "days_number": "max. Anzahl Tage",
  "contingent_number": "max. Anzahl Kontingente",
  "voucher_codes_none": "-",
  "voucher_codes_new": "Codes hinzufügen",
  "clone": "Duplizieren",
  "school_bonus": "Rabatt für Schulklassen",
  "add_payment": "Zahlungen",
  "paymentList": "Zahlungsübersicht",
  "ec_maestro": "EC/Maestro",
  "cheques": "Cheques",
  "payment_request": "Payment Request",
  "checkout_finished": "Check-out abgeschlossen",
  "mietvertrag": "Mietvertrag",
  "mietvertrag_help": "Buchung herunterladen.",
  "mietvertrag_download_error": "Mietvertrag konnte nicht generiert werden. Wurde der Auftrag bereits ausgeführt?",
  "manual_override_help": "Überschriebenen Preis zurücksetzen",
  "next_available_opening_time": "Frühestens geöffnet ab/am",
  "found_invalid_voucher": "Ungültiger Gutschein",
  "filter_locations_list": "Standorte durchsuchen...",
  "payment_success": "Die Bezahlung wurde erfolgreich gespeichert.",
  "payment_error": "Fehler: Die Bezahlung konnte nicht gespeichert werden",
  "checkin_state_pending": "Check-In ausstehend",
  "checkin_state_checked_in": "Check-In erfolgt",
  "checkin_state_checked_out": "Check-Out erfolgt",
  "today": "Heute",
  "voucher_type_status_updated": "Voucher type status updated.",
  "contingent_empty": "Keine Ressource verfügbar",
  "edited_by": "von",
  "help": "Hilfe",
  "daily_rental_contract": "Tagesmietverträge",
  "rental_contract_type": "Art der Mietverträge",
  "rental_contract_type_normal": "Normal",
  "rental_contract_type_slowup": "Slowup",
  "rental_contract_error_empty": "Keine Buchungen an diesem Tag vorhanden",
  "rental_contract_error": "Mietvertrag konnte nicht generiert werden. Bitte probieren Sie es später erneut.",
  "rental_contract_warning": "Achtung: Mietvertrag ist nicht aktuell! Bitte den Auftrag erneut bestätigen. Trotzdem fortfahren?",
  "order_not_confirmed_warning": "Änderungen am Auftrag wurden noch nicht bestätigt!",
  "order_status_changed_without_email_warning": "Achtung, der Auftragsstatus wird hiermit geändert, ohne dass eine Benachrichtigung versendet wird! Dazu bitte anschließend den Button 'Versenden' klicken oder ggf. abbrechen und den Button 'Auftrag bestätigen und versenden' klicken.",
  "order_status_changed_without_email_warning_v2": "Achtung, der Auftragsstatus wird hiermit geändert, ohne dass eine Benachrichtigung versendet wird! Dazu bitte den Auftrag bearbeiten und dort den Button “Versenden” klicken oder den Vorgang abbrechen und im Bearbeitungsmodus den Button “Auftrag bestätigen und versenden” klicken.",
  "generate": "Generieren",
  "for": "für",
  "user_active_body": "Inaktive Nutzer können sich nicht einloggen.",
  "removed": "gelöscht",
  "user_added_to_order": "Nutzer wurde mit neuem Auftrag verknüpft.",
  "Datenschutzerklärung": "Datenschutzerkärung",
  "pre_booking_time": "Vorausbuchungsfrist",
  "units": "Zeiteinheiten",
  "minutes": "Minuten",
  "hours": "Stunden",
  "days": "Tage",
  "remove_booking_first": "Die Buchung enthält bereits gelöschte Standorte oder Kontingente und kann daher nicht bearbeitet werden.",
  "email_settings": "E-Mail Einstellungen",
  "email_setting_get_booking_info": "Buchungsinformation bei Statusänderung erhalten",
  "email_setting_get_damage_report": "Schadensmeldungen erhalten",
  "user_no_mail_confirm": "Es wurde keine E-Mail Adresse angegeben. Trotzdem fortfahren?",
  "user_mail_adress_incomplete": "Es wird empfohlen, eine E-Mail Adresse anzugeben.",
  "app_order_bike_tour_min_${a}": "Buchung via App (${a})",
  "user_not_exist_or_removed": "Nutzer konnte nicht gefunden werden, wurde also möglicherweise bereits aus dem System entfernt.",
  "voucher_error_value_greater_equal": "Negative Werte sind unzulässig. Bitte geben Sie einen Wert von 0 oder höher ein.",
  "no_price_warning": "Achtung: Tarif nicht wählbar oder keine Preise vorhanden (in diesem Fall MUSS Gesamtpreis der Buchung manuell auf 0 gesetzt werden).",
  "plantool": "Planungstool",
  "network": "Netzwerk",
  "networks": "Netzwerke",
  "no_plan_active": "Kein aktiver Plan gewählt.",
  "contingent_plans": "Kontingente planen",
  "plan_notification_title": "Kontingentanpassungen vorgemerkt",
  "contingent_changes": "Kontingentanpassungen",
  "reset_changes": "Anpassungen zurücksetzen",
  "active_search": "Aktive Suche",
  "available_prev_day": "Verfügbar ",
  "available_new": "Neue Verfügbarkeit",
  "generated_plan_${entries_length}": "Plan mit ${entries_length} Einträgen generiert.",
  "valid_at": "Gültig am",
  "orders_sales_billings": "Abrechnung",
  "orders_sales_billings_error": "Abrechnung konnte nicht generiert werden.",
  "no_location_selected": "Kein Standort gewählt.",
  "really_delete_${a}_contingent_items": "Diese Änderung würde die gewählten Kontingente `${a}` zurücksetzen. Änderung wird rückgängig gemacht.",
  "no_${a}_selected": "Kein/e ${a} gewählt.",
  "monthpicker_help": "Monat oder Jahr wählen und mit Klick auf Tag bestätigen",
  "plantool_saved_changes": "Gespeicherte Pläne",
  "plantool_your_search": "Ihre Suche",
  "pickups": "Abholungen",
  "valid_from_": "Gültig ab",
  "click_to_select_time": "Klicken um Zeit zu wählen",
  "really_change_time": "Der gewählte Zeitpunkt liegt außerhalb der Öffnungszeiten. Trotzdem fortfahren?",
  "plan": "Plan",
  "network_plans": "Netzwerke planen",
  "contingentPlans": "Kontingentplan",
  "networkPlans": "Netzwerkplan",
  "reservationsList": "Buchungen",
  "schedule": "Belegungsplan",
  "schedule_heart_route": "Belegungsplan Herzroute",
  "network_plan": "Netzwerkplan",
  "add_plan": "Hinzufügen",
  "hide_contingents": "hide",
  "show_contingents": "show",
  "closed_from_date": "Geschlossen ab/am",
  "new_search": "Neue Suche",
  "sales_billings": "Abrechnungen",
  "sales_billing": "Abrechnung",
  "file": "Dokument",
  "preview": "Vorschau",
  "salesBillings": "Abrechnungen",
  "sales_billing_already_exists": "Eine Abrechnung für das gewählte Datum existiert bereits.",
  "create_day_billing": "Tagesabschluss erstellen",
  "day_billing": "Tagesabschluss",
  "day_billing_error_empty": "Keine Zahlungen an diesem Tag vorhanden!",
  "create_${a}": "${a} erstellen",
  "starts_today": "Beginnen heute",
  "ends_today": "Enden heute",
  "ends_upcoming": "Ende bevorstehend",
  "starts_today_RAB": "Ausgaben heute",
  "ends_today_RAB": "Rücknahmen heute",
  "ends_upcoming_RAB": "Rücknahmen bevorstehend",
  "external_resource_id_short": "Betriebsnummer",
  "rental_contract_location": "Tagesmietvertrag für",
  "order_executed_at_${a}_with_active_status": "Buchungsinformation am ${a} mit aktuellem Status versendet.",
  "file_manager": "Dokumentmanager",
  "folder": "Ordner",
  "tags": "Tags",
  "tag": "Tag",
  "upload_${a}_files_here": "${a} Dokument(e) hier hochladen.",
  "document": "Dokument",
  "upload_in_progress": "(Am hochladen)",
  "folder_accessible_by": "Ordner freigeben für",
  "open_folder_${a}": "In Ordner `${a}` wechseln",
  "root_folder": "Stammverzeichnis",
  "payment_day": "Tagesfilter",
  "day_closing": "Tagesabschluss",
  "day_closing_total_${a}": "Gesamtsumme Tagesabschluss am ${a}",
  "saldo_from_${a}": "Saldo vom ${a}",
  "previous_saldo": "Vorheriges Saldo",
  "day_closing_print": "Tagesabschluss drucken",
  "day_closing_print_info": "Aktuelle gefilterte Auswahl als Tagesabschluss drucken",
  "change_wallet_info": "Konto wechseln",
  "transactions_view_info": "Transaktionen zeigen ausstehende Zahlungen und Geldeingänge an Aufträgen. Um einen Tagesabschluss zu generieren und auszudrucken bitte ein Datum und Standort auswählen.",
  "misc": "Sonstige",
  "amount_total": "Gesamtbetrag",
  "payments_amount_total": "Kasse Einnahmen TOTAL",
  "checkin_out_location": "Aktueller Standort",
  "user_doc": "Dokument",
  "user_docs": "Dokumente",
  "userDocs": "Dokumente",
  "help_desc": "Hilfe/Support",
  "tag_list": "Stichwörter",
  "group_names": "Gruppennamen",
  "still_chars_available_${a}": "Noch ${a} Zeichen",
  "text_limited_for_chars_${a}_${b}": "Text in '${a}' zu lang und wurde um ${b} Zeichen gekürzt",
  "checkin_error_resource_${a}_unavailable": "Achtung: Die Ressource ${a} wurde bereits an einer anderen Buchung eingecheckt. Diese bitte aus der Auswahl entfernen und eine neue auswählen.",
  "timespan": "Zeitraum",
  "timespan_from": "Zeitraum (von)",
  "timespan_to": "Zeitraum (bis)",
  "checkin_smart_resource_select": "Automatisch einchecken",
  "transaction_status_debit": "Status: Zahlung eingegangen",
  "transaction_status_credit": "Status: Zahlung offen",
  "payments_bestand_ist": "BAR Einnahmen IST Bestand Kasse am",
  "signature": "Unterschrift",
  "bank_transfer": "Überweisung",
  "fe_visible": "Im Frontend sichtbar",
  "oneway": "Einwegmiete",
  "checkin_single_resource": "Ressource einchecken",
  "checkin_single_resource_done": "Ressource eingecheckt",
  "checkout_single_resource": "Ressource auschecken",
  "checkout_single_resource_done": "Ressource ausgecheckt",
  "checkin_selection_complete": "Buchbare Ressourcen wurden ausgewählt.",
  "checkin_out_abort": "Zurück zur Buchung",
  "transports": "Transporte",
  "chooseable_contingents": "Passende Kontingente",
  "choosen_contingents": "Ausgewählte Kontingente",
  "navigate_up": "Aufwärts navigieren",
  "document_s": "Dokument(e)",
  "docs_with_tag": "Dokumente mit Tag",
  "filter_tag_${a}": "Zeige Dokumente mit Tag '${a}'",
  "add-dynamic-payment": "Zahlung hinzufügen",
  "remove_folder_forbidden": "Dieser Ordner enthält Dokumente und darf daher nicht gelöscht werden.",
  "error_folder_access_forbidden": "Keine Zugangsberechtigung für diesen Ordner.",
  "filemanager_msg_no_folders": "Willkommen im Dokumentmanager",
  "filemanager_msg_no_folders_body": "Hier können Ordner und Dokumente mit unterschiedlichen Berechtigungen angelegt und mit Mitarbeitern geteilt werden.",
  "new_folder_name": "Name des Ordners",
  "link_folders": "Sichtbar in Ordner",
  "available": "Verfügbar",
  "no_appointments_for_contingent": "Keine Termine für dieses Kontingent angelegt.",
  "reservation_error_missing_appointment": "Bitte wählen Sie einen Termin",
  "pers_short": "pers.",
  "update_appointment_selection": "Terminauswahl aktualisieren",
  "show form data": "Formulardaten anzeigen",
  "no_location_pick_one": "Bitte Standort wählen.",
  "no_periods_add_one": "Keine Saisons definiert.",
  "opening_times": "Öffnungszeiten",
  "all_times": "Zeiten",
  "holiday": "Ferien",
  "period": "Check-In Zeit",
  "no_checkin_no_booking": "Geschlossen",
  "copy_to_new_period": "Kopieren und als neue Check-In Zeit anlegen",
  "checkin_hours_valid_from": "Check-In Zeiten gültig ab",
  "please_pick_valid_date": "Gültiges Datum wählen",
  "mark_as": "Markieren als",
  "outside_hours": "Außerhalb dieser Zeiten",
  "check_in_on_request": "Check-In auf Anfrage",
  "check_out_on_request": "Check-Out auf Anfrage",
  "check_in_any_time": "Check-In jederzeit",
  "daily": "Täglich",
  "weekdays": "Wochentage",
  "day_non_working": "Dies löscht umgehend alle eingetragenen Uhrzeiten. Aktion wirklich ausführen?",
  "please_pick_valid_date_weekdays": "Bitte gültiges Datum wählen und Check-In Zeiten setzen.",
  "cant_save_period_0": "Fehler beim Speichern: Diese Öffnungszeit existiert bereits.",
  "cant_save_period_1": "Diese Daten sind identisch entweder zur vorangegangenen oder nachfolgenden Saison. Bitte überprüfen",
  "ot_all": "Alle Saisons",
  "ot_upcoming": "Bevorstehend",
  "ot_past": "Vergangene Saisons",
  "ot_today": "Startet heute",
  "booked": "gebuchte",
  "see_completed_checkin_out": "Check-In öffnen",
  "is_bikesharing_no_opening_times": "Hinweis: In einem Bikesharing-Account müssen keine Check-In Zeiten definiert werden",
  "regular_period": "Regulär",
  "form_data": "Formulardaten",
  "new_task_name": "Aufgabe hinzufügen",
  "edit task ${a}": "Aufgabe ${a} bearbeiten",
  "mediator": "Vermittler",
  "guide": "Guide",
  "begin": "Beginn",
  "success order confirmation": "Der Auftrag wurde erfolgreich bestätigt. Das Fenster kann nun geschlossen werden.",
  "error order confirmation": "Der Auftrag existiert nicht oder wurde schon bestätigt. Das Fenster kann nun geschlossen werden.",
  "task_list": "Aufgabenliste",
  "tasks": "Aufgaben",
  "task": "Aufgabe",
  "task_category": "Aufgabentyp",
  "task_status": "Aufgabenstatus",
  "product": "Produkt",
  "products": "Produkte",
  "filter_by_product_name": "Nach Name suchen...",
  "select_unselect_product": "Klicken um Produkt auszuwählen / zurücksetzen",
  "list deliveries": "Liste Anlieferungen",
  "order_edit": "Auftrag bearbeiten",
  "no_text_is_entered": "Bitte etwas eingeben!",
  "organization": "Organisation",
  "personal_contact": "Ansprechpartner",
  "recipient": "Empfänger",
  "invoice_address": "Rechnungsadresse",
  "delivery_address": "Lieferadresse",
  "pickup_address": "Abholung",
  "select_tag": "Tag auswählen",
  "${a}_products_added": "${a} Einheit(en) hinzugefügt",
  "single price": "Einzelpreis",
  "price info": "Preisinformation",
  "membership": "Mitgliedschaft",
  "membership_active": "Mitgliedschaft aktiv",
  "type_of_membership": "Art der Mitgliedschaft",
  "user_abo": "Abo",
  "get_user_by_card_nbr": "Nutzer nach Kartennummer wählen",
  "provision": "Provision",
  "user_registration_swisspass": "Registrierung via Swisspas",
  "duration": "Dauer",
  "service_transport": "Service/Transport/Puffer",
  "reserved": "Reserviert",
  "new_selected": "Neu gewählt",
  "unit_added": "Einheit hinzugefügt",
  "unit_deleted": "Einheit entfernt",
  "close": "Schliessen",
  "IE_not_supported_warning": "Diese Anwendung wurde für die Browser Microsoft Edge, Google Chrome, Mozilla Firefox und Apple Safari optimiert. Ihr Browser Internet Explorer wird nicht unterstützt. Die Anwendung wird nicht korrekt angezeigt.",
  "export_xls": "Export",
  "export_xls_contingents": "Export Kontingente",
  "export_xls_resources": "Export Ressourcen",
  "export_xls_reservations": "Export Buchungen",
  "export_xls_orders": "Export Aufträge",
  "add_contingents_products": "Kontingente und Produkte hinzufügen",
  "resources": "Ressourcen",
  "new": "Neu",
  "assigned": "Zugewiesen",
  "assignment": "Zuweisung",
  "in_progress": "In Bearbeitung",
  "done": "Erledigt",
  "done_until": "Zu erledigen",
  "booking_frontend": "Buchungsfrontend",
  "the payment was ${a}. Thank you!": "Die Zahlung war ${a}. Vielen Dank!",
  "successful": "erfolgreich",
  "email_setting_get_group_list": "Gruppenbuchungsliste erhalten",
  "email_setting_get_battery_lock_value": "Fahrzeugstatus (niedriger Batteriestand Schloss) erhalten",
  "link_products": "verknüpfte Produkte",
  "image": "Bild",
  "product type": "Produktart",
  "discountable": "Rabattberechtigt",
  "link_required_products": "Verknüpfte Produkte (Verpflichtend)",
  "required product": "verpflichtendes Produkt",
  "extra options": "Zusatzprodukte",
  "extra option": "Produkt",
  "selectbox": "Auswahl (Anzahl)",
  "checkbox": "Checkbox",
  "textbox_number": "Eingabe (Nur Zahlen)",
  "textbox_text": "Eingabe (Text)",
  "layout_type": "Ansicht im Frontend",
  "link_products_help": "Hier Produkte auswählen, zu welchen dieses Produkt dazu gebucht werden darf, leer lassen wenn zu jedem produkt auswählbar.",
  "link_required_products_help": "Hier Produkte auswählen, zu welchen dieses Produkt dazu gebucht werden muss, diese werden verpflichtend im Buchungsfrontend gebucht.",
  "lock": "Schloss",
  "bike": "Fahrrad",
  "advertiser": "Advertiser",
  "lock type": "Schlossart",
  "note": "Bemerkungen",
  "contingents_product": "Kontingent",
  "contingents_products": "Fahrzeuge",
  "fe_visible_product": "Für Nutzer wählbar",
  "map": "Karte",
  "amount_bookings": "Anzahl Buchungen",
  "product_contingents_help": "Bei Fahrzeugen müssen hier mindestens ein Kontingent hinzugefügt werden, für Zusatzprodukte nur notwendig wenn dieses auf Verfügbarkeit geprüft werden soll, dafür bitte 'Ansicht im Frontend' auf 'Auswahlfeld (Anzahl)' stellen",
  "email_setting_get_task_created": "neue Aufgabe erstellt wurde",
  "email_setting_get_task_changed": "eine Aufgabe geändert wurde",
  "email_setting_get_task_comment": "eine Aufgabe kommentiert wurde",
  "Resource defect": "Fahrzeug-Defekt prüfen",
  "FacilitySlot error": "Fehler Abstellanlageneinheit",
  "Facility error": "Fehler Abstellanlage",
  "Customer feedback": "Nutzerfeedback",
  "Resource not in slot": "Fahrzeug steht nicht in Abstellanlage",
  "Rental time exceeded": "Überziehung der Miete",
  "User Activation": "Nutzeraktivierung",
  "designation": "Bezeichnung",
  "contract": "Vertrag",
  "team_lead": "Verantwortlich",
  "comments": "Kommentare",
  "goto_vehicle": "Zum Fahrzeug",
  "goto_order": "Zum Auftrag",
  "goto_user": "Zum Nutzer-Profil",
  "goto_facility": "Zur Abstellanlage",
  "amount prices": "Anzahl Preise",
  "pricetariff type": "Gültig für",
  "amount_weekday_1": "Mo",
  "amount_weekday_2": "Di",
  "amount_weekday_3": "Mi",
  "amount_weekday_4": "Do",
  "amount_weekday_5": "Fr",
  "amount_weekday_6": "Sa",
  "amount_weekday_7": "So",
  "please": "bitte",
  "employee_number": "Stammnummer",
  "full": "voll",
  "half_full": "halb voll",
  "empty": "leer",
  "garage-staff": "Werkstatt",
  "day": "Tag",
  "closing": "Abschluss",
  "closing_total_${a}": "Summe vom ${a}",
  "closing_total": "Gesamtsumme",
  "closing_print": "Abschluss drucken",
  "closing_print_info": "Aktuelle gefilterte Auswahl als Abschluss drucken",
  "extension_possible": "Verlängerung möglich",
  "percent_from_uvp": "Prozent von UVP",
  "change_key": "Neuen Schlüssel setzen",
  "change_key_warning": "Achtung: ein bereits vorhandener Schlüssel wird dabei überschrieben!",
  "valid_from_${a}": "Gültig ab ${a}",
  "pricetariff_valid_froms": "Gültigkeiten",
  "pricetariff_valid_from": "Gültigkeit",
  "${a}_prices": "${a} Preis(e)",
  "add": "Hinzufügen",
  "reservation_overdraft": "Bei Überziehung einer Buchung",
  "overdraft_possible": "Überziehung möglich",
  "default_tariff": "Standardtarif",
  "add_task_for_manager": "Aufgabe an Manager",
  "extend_tariff_automatically": "Tarif automatisch verlängern und Zahlung buchen",
  "Open end with Payment": "Offenes Ende mit Zahlung",
  "Open end with pay authorization": "Offenes Ende mit Autorisierung der Zahlung",
  "discount_price_info": "Anzahl Tage ab wann der Rabatt gilt",
  "prices valid from": "Preise gültig ab",
  "visible as": "Darstellung als",
  "Inbooma Standard Product": "Standard Produkt",
  "standard products": "Standardprodukte",
  "email_setting_get_facility_error": "Fehlermeldungen zu Abstellanlagen erhalten",
  "email_setting_get_facility_slot_error": "Fehlermeldungen zu Abstellanlagen (Slot) erhalten",
  "email_setting_get_resource_not_in_slot": "Meldung erhalten wenn Fahrzeug nicht am Abstellplatz",
  "email_setting_get_manager_user_activation": "Meldung zur Aktivierung eines Nutzers",
  "email_setting_get_customer_feedback": "Meldung zu Kunden Feedback erhalten",
  "get_message_if": "Benachrichtigung erhalten wenn",
  "email_setting_get_rental_time_exceeded": "Meldung erhalten wenn Buchungszeit überschritten",
  "date_of_delivery": "Datum, Uhrzeit Anlieferung",
  "date_of_pickup": "Datum, Uhrzeit Abholung",
  "user_duplicate_warning": " Duplikat vorhanden!",
  "user_duplicate_info": "Es existiert mindestens ein weiterer Nutzer mit derselben E-Mail-Adresse!",
  "at_minimum_one_contingent_required": "Mindestens ein Kontingent muss hinzugefügt werden",
  "still_no_service_team": "Keine Aufgaben vorhanden",
  "print_rental_contract": "Mietvertrag drucken",
  "no_order_found": "Kein Auftrag gefunden!",
  "no_empty_designation_allowed": "Das Feld 'Bezeichnung' darf nicht leer sein!",
  "no_valid_object": "Das betreffende Objekt ist ungültig! Bitte überprüfen Sie die Eingabe.",
  "external_resource_nbr": "ext. Betriebs-Nr.",
  "resource_nbr": "Betriebs-Nr.",
  "first_unit_cost_free": "Erste Zeiteinheit kostenfrei",
  "first_unit_cost_free_info": "Erste Zeiteinheit ist immer kostenfrei",
  "missing_team_lead": "Bitte weisen Sie einen verantwortlichen Nutzer zu!",
  "short_description": "Kurzbeschreibung",
  "authorized": "autorisiert",
  "from": "ab",
  "Contingent is not available": "Nicht verfügbar",
  "not available because no contingent number is configured": "keine Anzahl konfiguriert",
  "email_setting_get_lock_battery_low": "Batterie vom Schloss niedrig",
  "unknown": "Unbekannt",
  "select_checkout_location": "Standort zum Auschecken wählen",
  "select_checkout_location_info": "Sie müssen einen Standort auswählen, um manuell auschecken zu können. Dieser gilt für alle Ressourcen.",
  "past_reservations": "Vergangene Buchungen",
  "push_changes_to_inbooma": "Änderungen in die Frontend Datenbank übernehmen",
  "incomplete_transactions_warning": "Achtung, es wurden nicht alle Transaktionen geladen! Bitte auf 'mehr laden' klicken, da der Abschluss sonst fehlerhaft sein kann. Trotzdem fortfahren?",
  "payment_reference": "Zahlungsreferenz",
  "not_named": "Nicht angegeben",
  "other_online_payment": "Andere Onlinezahlung",
  "online_payment": "Onlinezahlung",
  "accumulated_invoice": "Sammelrechnung",
  "sent": "Versendet",
  "failed_no_payment_method": "Fehler! Keine Zahlungsmethode hinterlegt.",
  "failed_payment": "Fehler! Zahlung fehlgeschlagen.",
  "paydate": "Zahlungsdatum",
  "paystatus": "Zahlungsstatus",
  "create own invoice": "Rechnung für Account erstellen",
  "create user invoice": "Rechnung für einen Nutzer erstellen",
  "switch": "Bitte wählen",
  "total": "Gesamt",
  "select month": "Monat wählen",
  "product_name": "Name des Produktes/Beschreibung",
  "changes": "Änderungen",
  "missing_parameters": "Fehlende Einstellungen",
  "missingContingents": "Kontingente fehlen",
  "missingCheckInPeriods": "Öffnungszeiten fehlen",
  "missingEndLocations": "Rückgabestationen fehlen",
  "push_changes": "Änderungen veröffentlichen",
  "jobsExtended": "Online-Buchung",
  "frontendChanges": "Online-Buchung",
  "changes_success_notification": "Änderungen werden im Buchungsfrontend veröffentlicht. Es kann ca. 5 min, bis die Änderungen sichtbar sind.",
  "changes_error_notification": "Aufgabe zur Veröffentlichung in das Buchungsfrontend konnte nicht angelegt werden",
  "contingent_required": "Bitte wählen Sie ein Kontingent.",
  "No coordinates and address not valid.": "Keine Koordinaten vorhanden und Adresse nicht gültig.",
  "ssid_of_network": "Wenn ein GeoFence angegeben wurde wird dies berücksichtigt, sobald die Resource nicht im GeoFence ist wird geprüft ob SSID angegeben und verfügbar. Wenn beides nicht angegeben, so kann das Fahrrad 'überall' abgegeben werden. ",
  "ssid": "SSID des Netzwerks",
  "are required": "ist/sind verpflichtend!",
  "no_upcoming_reservations": "Keine Bevorstehenden Buchungen vorhanden.",
  "tracking_app_marker_description": "App Check-in / Check-out",
  "tracking_gps_marker_description": "Fahrzeug GPS Position",
  "tracking_position_not_available": "Fahrzeug GPS Position nicht verfügbar",
  "last_update": "Stand",
  "payment_pending": "Zahlung ausstehend",
  "annotated_images": "Angehängte Bilder",
  "session_expired": "Session abgelaufen! Sie werden automatisch ausgeloggt. Bitte melden Sie sich erneut an.",
  "copy_to_clipboard": "In Zwischenablage kopieren",
  "select_checkout_date": "Datum zum Auschecken wählen",
  "select_checkout_time": "Zeitpunkt zum Auschecken wählen",
  "manual_checkout_hint": "Wenn keine Nachberechnung erfolgen soll oder ein technisches Problem vorliegt, stornieren Sie bitte die Buchung:",
  "checkout_price": "Checkout-Preis",
  "contingents_only": "Standard Kontingentverfügbarkeit",
  "contingents_prebooking_blocked": "Vorausbuchungsfrist blockiert Kontingente",
  "contingents_prebooking_resources": "Vorausbuchungsfrist blockiert ohne Ressourcen",
  "contingents_prebooking_request": "Anfrage in Vorausbuchungsfrist",
  "reservation-only": "Verfügbarkeit basierend auf Buchungen",
  "checkin": "Verfügbarkeit berücksichtigt checkins",
  "availability_check_options": "Optionen zur Einstellung der Verfügbarkeitsprüfung",
  "availability_rules": "Verfügbarkeitsregel",
  "availability_checkin": "Verfügbarkeit nach Checkin oder Buchung",
  "user_vcard_info": "Visitenkarte anzeigen",
  "orders_form_user_link_info": "Zum Nutzerprofil",
  "submit_single_checkout": "Checkout durchführen",
  "time": "Uhrzeit",
  "manual_checkout_heading": "Bitte geben Sie die korrekten Daten für den Check-out ein. Diese Daten werden für die Abrechnung und ggf. Zahlung verarbeitet.",
  "checkout_extend_hint": "Es liegt eine Überziehung der Miete vor! Das Kundenkonto wird zusätzlich belastet.",
  "use_for": "Nutzbar für",
  "user_payment_amount": "Betrag Nutzer",
  "client_payment_amount": "Betrag Anbieter",
  "first_usage_lock": "Erstnutzung des Schlosses",
  "previous_year": "Letztes Jahr",
  "previous_day": "Gestern",
  "quick_filter": "Schnellfilter",
  "show_user": "Nutzer Anzeigen",
  "user not found": "Benutzer nicht gefunden",
  "please add user to this group": "Bitte fügen Sie Benutzer zu dieser Gruppe hinzu",
  "you can only send notification to one usergroup": "Sie können die Benachrichtigung nur an eine Benutzergruppe senden",
  "current_year": "Laufendes Jahr",
  "current_month": "Aktueller Monat",
  "last_year": "Vergangenes Jahr",
  "last_month": "Im vergangenen Monat",
  "filter_by_date": "Filtern Nach Datum",
  "filter_by_time": "Filtern Nach Zeit",
  "filter_by_kilometer": "Filtern Nach Kilometer",
  "filter_by_number": "Filtern Nach Anzahl",
  "filter_by_type": "Filtern Nach Typ",
  "speed": "Geschwindigkeit",
  "private": "Private",
  "business": "Business",
  "everyone": "Alle",
  "checked_in_status": "Checked-In Status",
  "show_payment": "Zahlungen anzeigen",
  "only discount first unit": "Nur erste Einheit rabattieren",
  "do_refund": "Zurückerstatten",
  "image_size_error": "Das ausgewählte Bild ist zu groß. Bitte wählen Sie eine kleinere Datei.",
  "refund_success": "Zahlung erfolgreich zurückerstattet.",
  "payment_error_info": "Folgende Fehlermeldung haben wir von unserem Zahlungsanbieter während der Bezahlung erhalten: ",
  "really_change_logo": "Soll das Logo wirklich geändert werden?",
  "export vouchers": "QR-Code für Voucher erstellen",
  "booking_duration_options": "Einstellungen Buchungslänge",
  "minBookingDuration": "Mindestbuchungsdauer",
  "maxBookingDuration": "Maximalbuchungsdauer",
  "getQRCode": "QR-Code erstellen",
  "Voucher": "Gutschein",
  "refunded": "Zurückerstattet",
  "availability_info": "<h1>Einstellungen zur Verfügbarkeitsprüfung</h1></br><p style='color: red'>Achtung! Alle Einstellungen haben Einfluss auf die Verfügbarkeit. Durch falsche Einstellung kann es sein dass die Kontingente nicht korrekt buchbar sind. Unter dem Abschnitt 'Empfohlene Einstellungen' sind mögliche Konfigurationsvorschläge.</p><h2>Einstellungen Buchungslänge</h2></br><p>Hier kann entweder die Mindestbuchungsdauer oder die Maximalbuchungsdauer eingestellt werden, dies hat auf Vorrausbuchungen Einfluss.</p></br><h2>Verfügbarkeitsregel</h2></br><p>Folgende Optionen gibt es: </p><ul><li>Standard Kontingentverfügbarkeit</li><li>Vorausbuchungsfrist blockiert Kontingente</li><li>Vorausbuchungsfrist blockiert ohne Ressourcen</li><li>Anfrage in Vorausbuchungsfrist</li></ul></br><p>- <b>Standard Kontingentverfügbarkeit</b> beschreibt die Verfügbarkeit der Anzahl Kontingente die verfügbar sind zum Anfragezeitpunkt</p><p>- <b>Vorausbuchungsfrist blockiert Kontingente</b> Kontingent verfügbar bis Vorausbuchungsfrist. Keine Buchung nach Vorausbuchungsfrist.</p><p>- <b>Vorausbuchungsfrist blockiert ohne Ressourcen</b> Kontingent verfügbar bis Vorausbuchungsfrist. Buchung nach Frist wenn Resourcen am Standort verfügbar.</p><p>- <b>Anfrage in Vorausbuchungsfrist</b> Kontingent. Buchung bis Vorausbuchungsfrist bestätigt. Anfrage nach Vorausbuchungsfrist.</p></br><h2>Verfügbarkeit nach Checkin oder Buchung</h2></br><p>Folgende Optionen gibt es:</p><ul><li>Verfügbarkeit basierend auf Buchungen</li><li>Verfügbarkeit berücksichtigt checkins</li></ul></br><p>- <b>Verfügbarkeit basierend auf Buchungen</b> berechnet dieAnzahl verfügbarer Kontingente anhand der Buchungszeiten.</p><p>- <b>Verfügbarkeit berücksichtigt checkins</b> wie Verfügbarkeit basierend auf Buchungen, nur dass hier ein verfrühter CheckOut ein Fahrzeug schon früher freigibt.</p></br><h2>Empfohlene Einstellungen</h2></br><p>- <b>Für Bikesharing:</b> Verfügbarkeitsregel auf 'Vorausbuchungsfrist blockiert ohne Ressourcen' und Verfügbarkeit nach Checkin oder Buchung auf 'Verfügbarkeit berücksichtigt checkins', Vorrausbuchungsfrist auf mind. 1 Stunde. Dies bedeuted, dass innerhalb der Vorrausbuchungsfrist die Fahrzeuge auf Standort geprüft werden und ob diese verfügbar sind. Ausserhalb der Vorrausbuchungsfrist wird die reine Kontingentverfügbarkeit geprüft. Nach CheckOut ist das Fahrrad wieder verfügbar.</p><p>- <b>Für stationäre Fahrradvermieter:</b> Verfügbarkeitsregel auf 'Standard Kontingentverfügbarkeit' und Verfügbarkeit nach Checkin oder Buchung auf 'Verfügbarkeit basierend auf Buchungen' Hier werden rein die Anzahl Kontingent geprüft und als Verfügbar werden solche zurückgegeben, die nicht innerhalb einer Buchung sind.</p>",
  "really_delete_${a}": "`${a}` wirklich löschen?",
  "no data available": "Keine Daten verfügbar",
  "statistics": "Berichte",
  "fleet_statistics": "Flottenstatistik",
  "bookings_per_usage_type_per_month": "Anzahl Buchungen",
  "total_km": "Gesamtkilometer",
  "distance_per_booking": "Kilometer pro Buchung",
  "distance_per_bike": "Kilometer pro Rad",
  "total_bookings": "Buchungen",
  "bookings_per_mail_address_per_month": "Buchungen pro Nutzergruppe",
  "total_bookings_per_month": "Buchungen",
  "official": "Geschäftsfahrten",
  "booking": "Privatfahrten",
  "service": "Servicefahrten",
  "bookings_per_mail_address": "Buchungen pro Nutzergruppe",
  "users_per_mail_address": "Nutzerzugehörigkeit",
  "distances_per_usage_type": "Kilometer pro Nutzungsart",
  "bookings_per_usage_type": "Buchungen pro Nutzungsart",
  "previous_month": "Vorheriger Monat",
  "trip_type": "Nutzungsart",
  "total_distances_per_month": "Gesamtkilometer",
  "filter_by_speed": "Filtern nach Geschwindigkeit",
  "privacy": "Datenschutz",
  "tos": "Nutzungsbedingungen",
  "assign_usergroup": "Nutzergruppe zuweisen",
  "assign_usergroups": "Nutzergruppen zuweisen",
  "sales-billing already exists": "Es existiert bereits eine Umsatzabrechnung mit diesen Daten.",
  "usergroup": "Nutzergruppe",
  "usergroups": "Nutzergruppen",
  "domain": "E-Mail-Domain",
  "contingents_help": "Hier die Kontingente wählen, die von Nutzern in der Nutzergruppe gebucht werden dürfen. Leer lassen für alle Kontingente.",
  "pricetariffs_help": "Hier die Preistarife wählen, die für Nutzer in der Nutzergruppe gelten sollen. Leer lassen für alle Preistarife.",
  "No data found for client": "Es wurden keine Umsätze gefunden, welche abgerechnet werden können.",
  "You have to select a date.": "Bitte zuerst ein Monat wählen.",
  "You have to select a resourcetype.": "Bitte zuerst ein Typ wählen.",
  "You have to select a location.": "Bitte zuerst einen Standort wählen.",
  "You have to enter a name.": "Bitte einen Namen angeben.",
  "default": "Standard",
  "locations_help": "Hier die Standorte wählen, die von Nutzern in der Nutzergruppe gebucht werden dürfen. Leer lassen für alle Standorte.",
  "order_cancelled_error": "Auftrag konnte nicht storniert werden.",
  "usage_type_official": "Geschäftsfahrt",
  "usage_type_booking": "Privatfahrt",
  "usage_type_service": "Servicefahrt",
  "types": "Typ",
  "please_select": "Bitte auswählen",
  "invoice_date": "Rechnungsdatum",
  "service period": "Leistungszeitraum",
  "timeperiod selection": "Auswahl Zeitraum",
  "month selection": "Auswahl Monat",
  "invoice_exits_already_for_the_time_period_${a}": "Für diesen Leistungszeitraum oder einzelne Tage wurde bereits eine Rechnung erstellt: ${a}",
  "orders_sales_billings_error_no_reservations": "Es wurden keine abrechenbare Buchungen gefunden in dem Zeitraum.",
  "lock_battery": "Schlossbatterie",
  "resource_battery": "Fahrradbatterie",
  "signalSound": "Suchton",
  "theft": "Diebstahlmodus",
  "could not open/close lock": "Schloss konnte nicht geöffnet/geschlossen werden.",
  "resource_name": "Fahrzeugname",
  "rental_aborted_by_user": "Miete abgebrochen durch Nutzer",
  "name_or_resource_nbr": "Name / Betriebsnummer",
  "open_lock": "Schloss öffnen",
  "close_lock": "Schloss schliessen",
  "open_lock_warnig_${a}": "Möchten Sie den Befehl \"${a}\" wirklich senden? Bitte stellen Sie eine dauerhafte Internetverbindung und ausreichende Batteriekapazität sicher.\nSollte dieser Befehl und weitere fehlschlagen, muss das Schloss manuell geschlossen werden.",
  "get_postal_pdf": "Postalische Verifizierung",
  "task_nbr": "Aufgabe Nr.",
  "owns": "Eigene",
  "email_setting_get_user_defined": "Benutzerdefiniert",
  "app_order_bike_tour": "Buchung via App",
  "modified_at": "modifiziert am",
  "updated": "Aktualisiert",
  "messages": "Benachrichtigungen",
  "message": "Benachrichtigung",
  "notification_for_markdown": "Zum Anpassen des Stylings des Textes, einfach beliebige Textpassagen markieren und im Kontextmenü anpassen.",
  "carbonate_savings": "CO2 Einsparung",
  "${a}_co2_savings_to_short_drives_norderstedt": "Dies entspricht ${a} PkW-Fahrten in Norderstedt (Kurzstrecke < 10 km).",
  "${a}_co2_savings_to_norderstedt_luebeck": "Dies entspricht ${a} PkW-Fahrten von Norderstedt nach Lübeck (66 km).",
  "${a}_co2_savings_${b}_co2_savings": "Dies entspricht ${a} PkW-Fahrten in Norderstedt (Kurzstrecke < 10 km) oder ${b} PkW-Fahrten von Norderstedt nach Lübeck (66 km).",
  "previous": "Zurück",
  "next": "Vor",
  "showMore": "mehr",
  "daytime": "Tag",
  "allDay": "Ganztägig",
  "yesterday": "Gestern",
  "tomorrow": "Morgen",
  "There are no events in this range.": "Keine anstehenden Buchungen",
  "Request": "Anfrage",
  "Response Data": "Antwortdaten",
  "Stack Trace": "Fehler Stack",
  "Client ID": "Client ID",
  "Errors (API)": "API Fehlermeldungen",
  "Errors (APP)": "APP Fehlermeldungen",
  "show_${a}": "Zeige ${a}",
  "field": "Eigenschaft",
  "value": "Wert",
  "system_message": "Hinweis App/Frontend",
  "back": "Zurück",
  "settings": "Einstellungen",
  "general": "Allgemein",
  "bookings": "Buchungen",
  "cancel requested orders": "Angefragte Buchungen stornieren",
  "after": "nach",
  "send reminder mail for offers": "Sende Erinnerungsmail für Angebote",
  "cancel if no checkin": "Stornierung wenn kein Checkin erfolgt",
  "reservation buffer": "Pufferzeit zwischen Buchungen",
  "count of bookings": "Maximale Anzahl Buchungen",
  "count of bookings at same time": "Max. Anzahl gleichzeitige Buchungen",
  "show usage type": "Anzeige Auswahl Buchungstypen",
  "prebooking possible": "Vorrausbuchung möglich",
  "max booking time": "Maximale Buchungszeit",
  "primary color": "Primärfarbe",
  "secondary color": "Sekundärfarbe",
  "font-size": "Schriftgröße",
  "font": "Schriftart",
  "required_be": "Im Backoffice benötigt",
  "display_name": "Anzeigename",
  "allow_foreign_domains": "Erlaube andere Domains als eingestellt (Manager Aktivierung)",
  "allowed_domain": "Erlaubte Domains (mit Semikolion separiert eingeben)",
  "user fields frontends": "Nutzerfelder Frontendformulare",
  "user fields backoffice": "Nutzerfelder im Backoffice",
  "activated elements": "Aktive Felder",
  "deactivated elements": "Inaktive Felder",
  "line break": "Zeilenumbruch",
  "use memberships": "Nutzergruppen nutzen",
  "use code for verification": "Code zur Verifizierung nutzen",
  "verify email": "E-Mail Adresse verifizieren",
  "verify mobile number": "Mobilfunknummer verifizieren",
  "verify postal": "Postalische Adresse verifizieren",
  "use_memberships_info": "Mit diesem Schalter kann das Nutzen von Nutzergruppen aktiviert werden, um Nutzergruppen aber nutzen zu können muss mindestens eine Nutzergruppe angelegt und als Standard markiert werden. ",
  "use_code_for_verification_info": "Mit Aktivieren dieses Schalters wird anstatt eines Links ein Code in der E-Mail zur E-Mailverifizierung angezeigt, dies ermöglicht dem Nutzer sich direkt zu verifizieren ohne die Umgebung/App zu verlassen.",
  "verify_info": "Hier werden die verschiedenen Arten der Verifizierung eingestellt, je nachdem ob die Domain erlaubt ist (im Falle der E-Mail Verifizierung -> siehe Einstellungen Nutzerfelder Frontendformulare am Feld E-Mail) wird der Nutzer nach erfolgreicher Verifizierung auf aktiv gestellt und kann sich einloggen/buchen. Wenn mehrere Verifizierungen aktiviert sind, so müssen alle Verifikationen vom Nutzer gemacht werden bevor die Freischaltung erfolgt.",
  "verify_info_email": "Der Nutzer bekommt mit Abschluss der Registrierung eine Mail und kann sich über einen Link oder wahlweise über einen Code verifizieren.",
  "verify_info_mobile": "Der Nutzer bekommt am Ende der Registrierung eine SMS mit einem Code zugesendet, womit sich dieser verifizieren kann.",
  "verify_info_postal": "Der Nutzer muss ein Dokument mit einem QR-Code zugesendet bekommen, über welchen er sich verifizieren kann. Hierfür ist eine seperate Einrichtung notwendig.",
  "cancel_requested_orders_info": "Nach der eingestelleten Zeit und aktiviertem Schalter werden Anfragen automatisch storniert. Diese Einstellung ist im Moment nur für den stationären Verleih vorgesehen.",
  "send_reminder_mail_for_offers_info": "Nach eingestellter Zeit sowie aktiviertem Schalter wird hier eine Erinnerung zu einem Angebot versendet, welchs der Nutzer noch bestätigen muss. Diese Einstellung ist nur für den stationären Verleih vorgesehen.",
  "cancelNoCheckin_info": "Bei automatischer Stornierung wenn kein Checkin erfolgt wird nach abgelaufener Zeit die Buchung storniert, danach ist das Fahrzeug wieder verfügbar, die Freigabe des Fahrzeugs ist, wenn hier keine Einstellung erfolgt per Standard nach einer halben Stunde ohne Checkin wieder frei verfügbar.",
  "reservationBuffer_info": "Die Pufferzeit wird immer zum Ende der Buchngszeit (Checkout) angerechnet. Eine neue Miete des Fahrzeuges kann erst nach Ablauf der Pufferzeit gemacht werden. Bei Stornierung einer Miete wird die Pufferzeit allerdings nicht beachtet.",
  "countOfBookings_info": "Hiermit wird die Anzahl Buchungen gesamt oder gleichzeitig eingeschränkt. Ausgenommen sind hier stornierte und bereits abgeschlossene Buchungen.",
  "show_usage_type_info": "Mit dem Schalter wir dem Nutzer eine verpflichtende Auswahl der Art seiner Buchung zur Verfügung gestellt, dies ist enbtweder dienstlich oder privat.",
  "pre_booking_possible_info": "Dieser Schalter ermöglicht es Buchungen in der Zukunft anzulegen. Da in der Zukunft nicht exakt vorhergesagt werden kann welches Fahrzeug auch an dem Zeitpunkt an dem Standort steht kann es hier auch zu einem Mehraufwand für Vermieter kommen.",
  "maxBookingTime_info": "Hier wird die maximale Buchungszeit eingestellt, diese überschreibt die eingestellte Buchungszeit an der Station. Sollte für eine Station eine andere maximale Buchungszeit gelten, muss nach Einstellung der maximalen Buchungszeit hier diese an der Station nochmal geändert werden.",
  "agb": "Nutzungsbedingungen",
  "colors_info": "Hier kann die Primär- sowie Sekundärfarbe eingestellt werden, dies hat sofortige Auswirkung für die App. Für das Buchungsfrontend sowie Backoffice muss allerdings eine Einstellung durch den Entwicklker erfolgen, der nach Einstellung hier benachrichtigt wird.",
  "agb_info": "Hier können die Nutzungsbedingungen oder ein Link zu diesen hinterlegt werden.",
  "help_info": "Hier kann der Text zur Hilfe / FAQ's hinterlegt werden.",
  "admin_fields_info": "Hier werden die Einstellungen vorgenommen, welche Felder im Backoffice unter Nutzer erstellen/bearbeiten sichtbar (aktiv) sein sollen. Per Drag und Drop können einzelne Felder aktiv oder inaktiv geschaltet werden. Über das Kontextmenü des Feldes (...) können darüber hinaus weitere Einstellungen für das Feld vorgenommen werden. Eine Reihenfolge der Felder wird hier allerdings nicht geändert.",
  "user_fields_info": "Hier werden die Einstellungen vorgenommen, welche Felder in der App oder Frontend im Registrierungsformular sichtbar (aktiv) sein sollen. Per Drag und Drop können einzelne Felder aktiv oder inaktiv geschaltet werden. Über das Kontextmenü des Feldes (...) können darüber hinaus weitere Einstellungen für das Feld vorgenommen werden. Des weiteren kann mit Setzen des Haken an 'Zeilenumbruch' ein Zeilenumbruch nach dem Feld forciert werden. Darüber hinaus kann per Drag und Drop auch die Reihenfolge der Felder eingestellt werden, wie diese angezegt werden. Hierbei gilt das WYSIWYG Prinzip.",
  "Something has changed, are you sure that you want to close without save?": "Es gibt ungespeicherte Änderungen, soll das Fenster ohne zu speichern wirklich geschlossen werden?",
  "voucher for temporary user": "Gutschein für temporären Nutzer",
  "which will be used for temporary user": "welche für den einmaligen Login gelten",
  "create": "erstellen",
  "voucher for temporary user_info": "Hier kann ein Gutschein erstelt werden für einen Nutzer der sich nicht registrieren soll oder brauch für eine einmalige Buchung. Dabei wird ein temporärer Nutzer ohne reale Nutzerdaten angelegt und den gewählten Nutzergruppen hinzugefügt. Der Gutschein (QR-Code) ist 30 Tage ab Erstellung gültig und verliert danach seine Gültigkeit.",
  "blocktime ends in": "Pufferzeit endet in",
  "follwowing users": "dies betrifft folgende Nutzer",
  "email_setting_get_edit_vehicle": "Meldung erhalten, wenn Wartungsarbeiten angefallen sind",
  "no results found": "Keine Ergebnisse gefunden",
  "validPeriod": "Gültigkeit des Logins",
  "Errors": "Fehlermeldungen",
  "without product": "Ohne Produkt",
  "Please enter the following fields: ": "Bitte folgende Felder ausfüllen: ",
  "box trackings": "Zutrittsprotokoll",
  "error while removing.": "Fehler beim Löschen.",
  "mengenrabatt_info": "Hier kann ein Preis angegeben werden, welcher ab einer bestimmten Einheit gelten soll. Für Einheiten davor gilt der Standardpreis.",
  "from the": "ab dem",
  "from the hour": "von der",
  "day_single": "Tag",
  "show trackings": "Zeige Zutrittsprotokoll",
  "cyclepoint": "Fahrradabstellanlage",
  "general_paketin_admin": "Schliessanlage",
  "general_paketin_pin": "Schliessanlage mit Pin",
  "single_paketin_admin": "Einzelschliessanlage",
  "single_paketin_pin": "Einzelschliessanlage mit Pin",
  "none": "Keine",
  "facility_type": "Art der Anlage",
  "close generate new pin dialog": "Neuen Pin erstellen abbrechen",
  "generate new pin": "Einen neuen Pin für einen Auftrag erstellen",
  "free boxes": "Freie Fächer/Boxen",
  "timeperiod": "Von - Bis",
  "From and to may not have the exact same date and time.": "Von und Bis dürfen nicht übereinstimmen.",
  "box": "Fach/Box",
  "counter": "Öffnungen",
  "customer pin": "Kunden-PIN",
  "merchant pin": "Händler-PIN",
  "no free box": "Kein freies Fach/Box verfügbar",
  "beginning soon": "Beginnt später",
  "boxes": "Fächer/Boxen",
  "deleted": "Gelöscht",
  "sent_signal_sound_to_${a}": "Alarmton an ${a} gesendet.",
  "error_sending_signal_sound_to_${a}": "Fehler beim Senden des Alarmtones an ${a}.",
  "sent_theft_mode_to_${a}": "Diebstahlmodus für ${a} angefordert.",
  "error_sending_theft_mode_to_${a}": "Fehler beim Setzen des Diebstahlmodus für ${a}.",
  "user_register_qr_code": "QR-Code für Registrierung erstellen",
  "display name": "Anzeigename",
  "url": "Webseite",
  "currency": "Währung",
  "ust_id": "Umsatzsteuer ID",
  "is_public": "Ist öffentlich sichtbar",
  "payment settings": "Zahlungseinstellungen",
  "leave it empty for all payment methods (without voucher, googlePay, applePay)": "Leer lassen für alle Zahlungsarten (ausser Gutscheine, ApplePay, GooglePay)",
  "paypal": "Paypal",
  "cart_voucher": "Gutschein für gesamte Buchung",
  "cart_item_voucher": "Gutschein für ein einzelnes Item",
  "visual_inspection": "Sichtprüfung",
  "visual_inspections": "Sichtprüfungen",
  "visual_inspection_item": "Sichtprüfung Einheit",
  "visual_inspection_items": "Sichtprüfung Einheiten",
  "or leave empty for all": "oder leer lassen für alle",
  "Show available dates for every": "Zeige verfügbare Daten für jede(n)",
  "weekday": "Wochentag",
  "closed visual inspection for contingent.": "Sichtprüfung für Kontingent abgeschlossen.",
  "closed visual inspection.": "Sichtprüfung abgeschlossen.",
  "Set multi visual inspections": "Mehrere Sichtprüfungen erstellen",
  "found dates": "Gefundene Daten",
  "multiple visual inspections": "mehrere Sichtprüfungen",
  "no valid dates found": "Keine Daten gefunden.",
  "no dates selected": "Keine Daten gewählt.",
  "ParkingLots": "Stellplätze",
  "all (without cancelled)": "Alle (ohne Stornierte)",
  "changelog": "Änderungen",
  "no changelog found": "Keine Änderungen gefunden",
  "close changelogs dialog": "Änderungen Dialog schliessen",
  "Command was sent successfully. Please stay patient, you`ll be notified": "Befehl wurde erfolgreich gesendet. Du wirst über den Erfolg/Misserfolg in Kürze benachrichtigt.",
  "You must allow your browser that this sie may notify you.": "Wir benötigen die Berechtigung von deinem Browser dich zu benachrichtigen. Bitte stelle dies in deinem Browser ein.",
  "Update cookies preferences": "Einstellungen Privatsphäre",
  "Allow to notify": "Erlaubnis Benachrichtigungen zulassen",
  "Want to get notification from us?": "Das System benötigt die Erlaubnis, dir Benachrichtigungen zu senden. Benachrichtigungen werden versendet bei bestimmten Aktionen anderer Nutzer:innen (bspw. Defektmeldung eines Fahrzeugs über die Sharing App). Darüber hinaus ist diese Erlaubnis erforderlich, um kontinuierlich Hintergrundupdates durchführen zu können.",
  "Please push the button 'Allow', to allow notifications.": "Bitte klicke den Button \"Erlauben\", um diese Benachrichtigungen zuzulassen.",
  "Please add this page to the Home screen and start it from there.": "Bitte füge diese Seite zum Startbildschirm hinzu (Teilen -> Zum Home-Bildschirm) und öffne die Seite von dort.",
  "Don't want to have notifications": "Ich möchte keine Benachrichtigungen erhalten",
  "Share": "Teilen betätigen",
  "To Home Screen": "Option 'Zum Home-Bildschirm' auswählen",
  "Start from icon": "Aufruf der Seite vom Icon auf dem Startbildschirm",
  "Push allow": "Erlauben auswählen",
  "Click on Share.": "Auf Teilen-Button klicken.",
  "Click on Add To Homescreen.": "Zum Home-Bildschirm auswählen.",
  "Start side from icon on homescreen.": "Diese Seite über das neu erstellte Icon auf dem Startbildschirm starten.",
  "Please do the following steps": "Bitte folgende Schritte ausführen",
  "insurances": "Versicherungen",
  "insurance": "Versicherung",
  "insurance_certificates": "Zertifikate",
  "insurance certificates": "Zertifikate",
  "payment_cycle": "Zahlungszyklus",
  "insurance_provider": "Anbieter",
  "subscription": "Abonnement",
  "notification_days": "Anzahl Tage für Benachrichtigung",
  "certificates": "Zertifikate",
  "certificate": "Zertifikat",
  "number": "Nummer",
  "cancel_before_next_cycle": "Stornierung vor dem nächsten Zyklus",
  "uvp": "Unverbindiliche Preisempfehlung",
  "frame_nbr": "Rahmennummer",
  "admin transactions": "Client Transaktionen",
  "income": "Einnahmen",
  "fees": "Gebühren",
  "sums for clients for stripe": "Auszahlungssummen einzelne Clients",
  "sum to transfer from paypal": "Summe die von PayPal überwiesen werden muss",
  "sum to transfer to stripe": "Summe zur Überweisung an Stripe",
  "sum fees": "Summe der Gebühren",
  "payment type": "Zahlart",
  "sepa_debit": "SEPA Lastschrift",
  "no location": "Alle Stationen",
  "the whole day": "ganztägig",
  "valid time": "Gültigkeitszeit",
  "valid times": "Gültigkeitszeiten",
  "in_weekdays": "wochentags",
  "everyday": "täglich",
  "weekend": "Wochenende",
  "for what": "Auswahl",
  "price_season_times": "Preissaison",
  "all rides": "Alle Fahrten",
  "RESERVATION": "Reservierung",
  "ORDER": "Auftrag",
  "APPLOG": "Konnektivität",
  "CHANGE_ORDER": "Änderung Auftrag",
  "CHANGE_RESERVATION": "Änderung Reservierung",
  "APPERROR": "Fehler in App",
  "ERROR": "Fehler",
  "GEOTRACKING": "Schlossänderung",
  "TRACKING": "Allgemeine Änderung",
  "show log": "Ereignislog (Beta)",
  "log entry": "Logeintrag",
  "count of errors": "Anzahl Fehler",
  "count_resources_bookable_at_same_time": "Anzahl wählbare Resourcen zu einer Buchung",
  "successfully opened the door": "Tür wurde erfolgreich geöffnet.",
  "code must be saved to create a qr code": "Gutscheincode muss gespeichert sein, um ein QR-Code daraus erstellen zu können.",
  "tab_v_login": "Gutscheine Einmalige Buchungen",
  "log": "Ereignislog (Beta)",
  "checkIn": "Check-In",
  "checkout": "Check-Out",
  "Online payment": "Online-Zahlung",
  "Offline payment": "Offline-Zahlung",
  "Return time exceeded": "Rückgabezeit überzogen",
  "overall connectivity": "Gesamtkonnektivität",
  "bluetooth": "Bluetooth",
  "gps": "GPS",
  "wifi": "WLAN",
  "user_free_unit_able": "Nutzer darf Anzahl Einheiten kostenfrei nutzen",
  "amount_cost_free_contingents": "Anzahl kostenfreie Einheiten",
  "amount_cost_free_contingents_info": "'Anzahl kostenfreie Einheiten' dient der Einstellung der Anzahl kostenfreier Einheiten (Kontingente) einer Buchung. In der Preisberechnung wird diese Einheit als kostenfrei erfasst. Alle weiteren gewählten Einheiten einer Buchung im selben Buchungszeitraum, die diese Anzahl übersteigen, werden berechnet.",
  "user_free_unit_able_info": "Wenn aktiviert, kann der Nutzer die Anzahl Einheiten, die im Preistarif unter 'Anzahl kostenfreie Einheiten' eingestellt werden können, zur gleichen Zeit kostenfrei nutzen.",
  "priority": "Priorität",
  "errortype": "Fehlertyp",
  "show create lock": "Schloss ID erstellen anzeigen",
  "close create lock": "Schloss ID erstellen schliessen",
  "create lock": "Schloss ID erstellen",
  "external_id": "Externe ID",
  "warning delete lock": "Warnung! Alle Schlossdaten werden beim Speichern entfernt, die Resource kann nicht mehr als Fahrrad gebucht werden. Bist du sicher?",
  "charging_state": "Ladestand",
  "select all": "Alle auswählen",
  "select none": "Auswahl aufheben",
  "multi switch": "Mehrfachauswahl",
  "selection": "Auswahl",
  "end multi switch": "Mehrfachauswahl verlassen",
  "task type": "Aufgabentyp",
  "multi edit": "Mehrfachauswahl bearbeiten",
  "selected": "Ausgewählte",
  "really_delete_${a}_${b}": "Möchtest du wirklich ${a} ${b} löschen?",
  "edited": "bearbeitet",
  "query must be number": "Suchanfrage muss numerisch sein",
  "geofence must be higher than 0m.": "Geofence muss mehr als 0 Meter betragen.",
  "restore user": "Nutzer wiederherstellen",
  "restore": "Wiederherstellen",
  "really_restore_user": "Gewählten Nutzer wiederherstellen?",
  "restored_${a}": "${a} wiederhergestellt",
  "stored_${a}": "${a} gespeichert",
  "deleted_${a}": "${a} gelöscht",
  "purge user": "Nutzer endgültig löschen",
  "purged_${a}": "Nutzer entgültig gelöscht",
  "email_setting_get_user_delete_request": "Meldung zu Löschanfrage vom Nutzer",
  "really_hard_remove": "Wirklich endgültig löschen",
  "cancel_possible_info": "Entscheidet, ob es dem Nutzer möglich sein soll seine Buchung zu stornieren, solange er seine Fahrt nicht entgültig angetreten hat.",
  "end_changeable_info": "Dies entscheidet darüber, ob der Nutzer das Ende der Buchung frei wählen darf, oder ob der Tarif das Ende der Buchungszeit entgültig festlegt.",
  "booking time": "Buchungszeit",
  "no orders found.": "Keine Aufträge gefunden.",
  "no customers found.": "Keine Nutzer gefunden.",
  "amount booked ${a}": "Anzahl gebuchter ${a}",
  "amount checkins ${a}": "Anzahl eingecheckter ${a}",
  "invoices": "Rechnungen",
  "invoiceDate": "Rechnungsdatum",
  "invoiceNbr": "Rechnungsnr.",
  "amountNetto": "Netto",
  "amountBrutto": "Brutto",
  "paymentMethod": "Zahlungsmethode",
  "paymentStatus": "Zahlstatus",
  "paymentDate": "Zahldatum",
  "dueDate": "Zahlbar bis",
  "warningLevel": "Mahnstufe",
  "mwstAmount": "Betrag MwSt.",
  "create Sepa XML": "SEPA XML erstellen",
  "positions": "Positionen",
  "defects": "Mängel",
  "actions": "Aktionen",
  "upload csv": "Rechnung (CSV) hochladen",
  "The": "Die",
  "is actually in a rent, please check it out.": "befindet sich momentan in einer Miete und ist eingecheckt. Bitte hier auschecken.",
  "download": "Herunterladen",
  "get sepa xml": "SEPA XML Datei erstellen",
  "weeks": "Wochen",
  "months": "Monate",
  "years": "Jahre",
  "minimal duration": "Mindestdauer",
  "please add user to this abonnement": "Bitte Nutzer zu diesem Abonnement hinzufügen",
  "external resource id": "Externe Fahrzeug ID",
  "firmware version": "Firmware Version des Schlosses",
  "client_documents": "Dokumente für Clients",
  "client_doc": "Dokument für Clients",
  "no station": "Kein Abholstandort hinterlegt",
  "${a} successfully restarted": "${a} erfolgreich neu gestartet",
  "test rds": "Test/Staging Datenbank",
  "test ec2": "Test/Staging Server",
  "live rds": "Live Datenbank",
  "live ec2": "Live Server",
  "Restart ${a}": "${a} neu starten",
  "aws_rds_instances": "Datebankserver",
  "help messages": "Hilfstexte",
  "help message": "Hilfstext",
  "title english": "Titel (englisch)",
  "title german": "Titel (deutsch)",
  "content english": "Inhalt (englisch)",
  "content german": "Inhalt (deutsch)",
  "help message item": "Hilfecontext",
  "help message items": "Hilfecontexte",
  "screen": "Ansicht",
  "fontSize": "Schriftgrösse",
  "show once": "Einmalig anzeigen",
  "closeable": "Schliessbar",
  "no paymentmethods configured": "Keine Zahlungsmethoden hinterlegt.",
  "payment method for abonnement": "Zahlungsmethode für Abonnements",
  "Do you really want to remove this abonnement? Payments collected will not be refunded.": "Möchtest Du wirklich das Abonnement enfernen? Eingezogene Zahlungen werden nicht erstattet.",
  "leave it empty for standard payment methods": "Leer lassen um die Standard Zahlungsmethoden zu verwenden",
  "filter explicit": "Explizit filtern",
  "auto_checkout_info": "Dies ermöglicht die Einstellung an der Abstellanlage, ob beim Einstellen eines Rades automatisch ein CheckOut durchgeführt werden soll.",
  "filter by": "filtern nach",
  "additional_info": "Zusatzinformation",
  "deposit": "Kaution",
  "t_deposit": "Kaution",
  "t_booking": "Buchung",
  "t_abonnement": "Abonnement",
  "export_sdf": "SDF exportieren",
  "begin and end must be filled": "Start und Ende müssen angegeben werden",
  "applePay": "ApplePay",
  "googlePay": "GooglePay",
  "switch visibility": "Sichtbarkeit ändern",
  "pre_auto_checkout_info": "Diese Einstellung ermöglicht, dass automatisch eine freie Resource eingecheckt wird beim Ausführen eines Auftrages. Das automatische (vorraus) Auschecken kann seperat eingestellt werden.",
  "shared_locations_for_resources_info": "Das Aktivieren der Einstellung ermöglicht, dass eine Resource unabhängig von ihrem Standort gebucht werden kann, wenn das Kontingent an mehreren Standorten hängt.",
  "with_ticket_on_message_info": "Wenn aktiviert, wird automatisch der Mietvertrag als PDF mit an die Auftragsbestätigungsmail als Anhang versendet.",
  "dontShowMinutes": "Keine Zeitauswahl",
  "begin location": "Start-Standort",
  "enableBikeFilters": "Anzeige Filter für Produkte",
  "start page": "Startseite",
  "webname": "Webname",
  "minute interval": "Intervall der Minuten in Auswahlbox",
  "show tariff filter": "Zeige Preistarifauswahl",
  "disable end calendar": "Keine Auswahl der Endzeit und des Enddatums",
  "default priceTariff": "Standart Preistarif",
  "minReservationLimits": "Mindestanzahl Kontingente",
  "maxReservationLimits": "Maximalanzahl Kontingente",
  "is bikesharing": "Ist BikeSharing",
  "is public": "Ist Öffentlich",
  "redirect to": "Weiterleiten nach",
  "enable payments": "Erlaube Zahlungen",
  "enable payment method at register step": "Ermöglicht Hinterlegung der Zahlungsdaten bei Registrierung",
  "require payment method at register step": "Erfordert Hinterlegung der Zahlungsdaten bei Registrierung",
  "require presaved payment method at checkout step": "Erfordert bereits gespeicherte Zahlungsdaten bei Buchung",
  "pay at location": "Erlaube Barzahlung",
  "has price": "Zeige Preise",
  "url to privacy policy": "URL zur Datenschutzerklärung",
  "class for container": "Klasse für umliegenden HTML-Container",
  "cart preset": "Vorausgewählter Warenkorb",
  "frontend url parameter": "Parameter Frontend-URL",
  "french": "Französisch",
  "france": "Frankreich",
  "german (Switzerland)": "Deutsch (Schweiz)",
  "italian": "Italienisch",
  "locations page": "Mietdaten",
  "bikes page": "Angebot",
  "carts page": "Warenkorb",
  "profile page": "Persönliche Daten",
  "register page": "Registrierung",
  "allows to force minutes dropdowns being in the disabled state.": "Wenn aktiviert, werden keinerlei Zeiten auswählbar sein und auch nicht in dem gesamten Buchungsverlauf angezeigt.",
  "Default value is false.": "Standartwert ist: Inaktiv.",
  "Default value is true.": "Standartwert ist: Aktiv.",
  "to set init language. Avaialale languages are:": "Zum initialen Setzen der Sprache. Verfügbare Sprachen sind:",
  "to set the location to start with.": "Die Startstation mit welcher begonnen werden soll.",
  "to enable filtering dropdowns on the Bikes Page.": "Aktivieren, um Produktkombinationen auf der Angebotsseite auswählen/filtern zu können.",
  "applies filter to the begin locations list.": "Filtert die Stationen nach dem angegebenen Netzwerk.",
  "app will redirect from home / url to the page specified in the start page.": "Das Frontend startet direkt mit der angegebenen Seite.",
  "applies filter to the register and profile pages matrix_fields list.": "Filtert die Matrixfelder nach einem Webnamen, z.B. wenn Stationen andere Registrierungsfelder inneralb eines Clients benötigen.",
  "allows to define interval in minutes for hour options dropdown.": "Hier kann der Intervall eingestellt werden für die Schritte in welchen die Minuten angezeigt werden. Standartmässig sind einminütige Schritte eingestellt.",
  "shows Tariffs selector on /locations page and disables Tariff selectors on /bikes, /products and /cart pages.": "Zeigt Auswahl Preistarife im Schritt Mietdaten und deaktiviert die Auswahl des Preistarif in den Schritten 'Angebot', 'Zubehör' und im Warenkorb.",
  "shows buttons to change usage type on /locations page. Works only in combination with showTariffFilter=true.": "Zeigt Schalter im Schritt Mietdaten an um den Nutzungstyp zu bestimmen. Funktioniert nur, wenn 'Zeige Preistarifauswahl' aktiviert ist.",
  "allows to force DropoffDateCalendar being in the disabled state.": "Deaktiviert die Auswahl des Enddatums sowie der Endzeit.",
  "to set the default pricetariff to fetch prices.": "Der Standarttarif, welcher für die Preisberechnung genommen werden soll.",
  "to set the minimal amount of contingents that can be selected on the /bikes.": "Bestimmt die Mindestanzahl der Kontingente, die zu einer Buchung hinzugefügt werden müssen.",
  "to set the max amount of contingents that can be selected on the /bikes.": "Bestimmt die Maximalanzahl der Kontingente, die zu einer Buchung hinzugefügt werden dürfen.",
  "enables bike sharing mode on the /bikes page if set to bikeSharing=true. So customer can pick only one contingent per booking.": "Aktiviert den Modus für BikeSharing. Der Kunde kann hier nur noch ein Kontingent pro Buchung buchen.",
  "if set to isPublic=true than token and user data will be erased from cookies\\local_storage immediately after app is loaded and also if redirectTo is present than it will erase token and user data before redirecting.": "Wenn 'Ist Öffentlich' aktiviert wurde, wird der Token sowie die Nutzerdaten aus dem Cookie gelöscht, obald das Frontend geladen wurde. Dies gilt auch, wenn der Schalter 'Weiterleiten nach' gestezt wurde.",
  "to set the redirect url. Redirect url will include additional url parameter id representing the current user id after login or registering a new user. Is used to register a new user and return user id to provided url value from redirectTo parameter.": "Hier wird eine URL zur Weiterleitung gesetzt. Die URl wird zusätzliche Parameter wie 'user_id' nach dem Login oder der Registrierung beinhalten. Wird normalerweise dazu benutzt um einen neu registrierten Benutzer wieder zurück zu leiten.",
  "Url example: ": "Beispiel URL: ",
  "After registering a new user the redirect effect will fire pointing the browser to https://otherwebsite.domain/users/add?id=nnnnnnnnnnnnn": "Nach der Nutzerregistration wird der Browser zu 'https://otherwebsite.domain/users/add?id=nnnnnnnnnnnnn' weiterleiten",
  "makes payment pages, buttons, links to show up in the booking process. If false or order price is 0 then payment page will redirect to the next page automatically.": "WErlaubt Zahlungen im Buchungsfrontend. Wenn Preis 0 ist oder der Schalter deaktiviert, wird der Nutzer automatisch zm nächsten Schritt weiter geleitet (Zahlung übersprungen).",
  "shows up a payment method page to require at least one payment method added during new user registration.": "Erlaubt die Einstellung, sowie das Hinzufügen einer Zahlungsmethode direkt bei der Registration.",
  "desides if skip button will be shown at the bottom of payment method page during new user registration.": "Dieser Schalter entscheidet darüber, ob der 'Überspringen' - Knopf unten angezeigt wird bei den Zahlungsmethoden, wenn aktiv, so muss mindestens eine Zahlungsmethode konfiguriert werden, bevor man die Seite verlassen kann.",
  "if set to true only the payment methods added through the manage payment methods page will show up in the select payment method dropdown at the order summary page.": "Wenn aktiviert, so werden nur die vorkonfigurierten zahlungsmethoden im Buchungsschritt angezeigt.",
  "If set to false the select payment method dropdown will also display options that allow to pay with new credit card, new sepa or new paypal agreement.": "Wenn deaktiviert, kann zusätzlich noch Paypal oder Kreditkarte neu angelegt werden.",
  "In that case at the next screen it will be required to enter new card number (sepa, paypal etc) and it will be saved for the future use after successful payment.": "In diesem Fall werden auf der nächsten Seite die daten zu der neuen Zahlungsmethode abgefragt und für die Zukunft gespeichert.",
  "Please note that this parameter is not related to paypal Smart Payment Buttons payment method and that needs to be setup separately at the API backend in the client_settings parameter named payment_methods.": "",
  "makes 'Cash' option to show up among payment options. This way user can navigate directly to the Confirmation page without making actual payment.": "Ermöglicht die Zahlungsmethode 'Barzahlung'. Die Zahlung wird hier übersprungen und der Nutzer direkt zur Zusammenfassung weitergeleitet.",
  "if set to false the price values will not be shown. Please note that getPrice endpoint will be called in any case, this parameter only allows to not display the price component.": "Dieser Parameter verstckt die Preise im gesamten Buchungsfrontend. Die Preisberechnung findet im Hintergrund dennoch statt.",
  "set the url to Privacy Policy.": "Setzt die URL zu einer externen Datenschutzerklärung des Clients.",
  "adds this class to the app layout container allowing you to create extra styles for the specific app embedments. Can be usefull when app with the same client_id is embedd in several websites with different design.": "Fügt die Klasse zu einem 'AppLayoutContainer' hinzu um extra Styles sowie Einbettungen zu ermöglichen. Kann nützlich sein wenn Clients auf ihren Webseiten verschiedene Einbettungen und/oder Designs benutzen.",
  "allows to start the app with contingents and products already added to the cart, as well as start_location, end_location, pickup_datetime and dropoff_datetime. Use this parameter together with startPage=cart parameter to land user on the cart preset page.": "Ermöglicht es, das Buchungsfrontend direkt mit befülltem Warenkorb (mit Kontingenten und Podukten) zu starten. Ebenso können so Standorte, Zeiten und Tarife der Buchung festgelegt werden. Als Startseite sollte 'Warenkorb' eingestellt werden, um den Nutzer direkt zum vorgefertigten Warenkorb zu leiten.",
  "The parameter is an base64 encoded object with the following structure:": "Der Parameter hat folgende Struktur:",
  "description long": "Beschreibung (lang)",
  "conditions": "Bedingungen",
  "waiveRightsOfWithdrawal": "Richtlinien für Abholung und Rückgabe",
  "default settings": "Grundeinstellungen",
  "report": "Auswertung gefahrene km pro Ressource",
  "reports": "Auswertungen gefahrene km pro Ressource",
  "reports_short": "Auswertung gefahrene km",
  "email_setting_get_report_info": "Bericht zu gefahrenen km pro Ressource erhalten",
  "token duration": "Dauer Gültigkeit Token",
  "category": "Kategorie",
  "kilometers driven per resource": "Gefahrene km pro Ressource",
  "view": "Ansehen",
  "replace": "Erneut erstellen",
  "description details": "Detaillierte Beschreibung",
  "yearly": "jährlich",
  "monthly": "monatlich",
  "weekly": "wöchentlich",
  "one time": "einmalig",
  "position": "Position",
  "priceinfo": "Preisinformation",
  "price test for": "Preise testen für",
  "close price test": "Preise testen beenden",
  "test price": "Preise testen",
  "calculate price": "Preis berechnen",
  "verification pending": "Verifizierung ausstehend",
  "bookable": "buchbar",
  "found resources": "Gefundene Fahrzeuge",
  "show found resources": "Zeige gefundene Fahrzeuge",
  "scantime": "Zeitpunkt Scan",
  "wrong_device_time_title": "Fehlerhafte Gerätezeit",
  "wrong_device_time_msg": "Die Uhrzeit auf deinem Gerät scheint nicht korrekt zu sein. Bitte überprüfe deine Datums- und Zeiteinstellungen und aktiviere gegebenenfalls die automatische Zeiteinstellung.",
  "wrong_device_time_deviation": "Abweichung",
  "wrong_device_time_current": "Aktuelle Uhrzeit",
  "wrong_device_time_device": "Deine Gerätezeit",
  "wrong_device_time_check_again": "Erneut prüfen",
  "wrong_device_time_close": "Schliessen",
  "order created": "Auftrag erstellt",
  "bookingtime": "Buchungszeitraum",
  "payment date": "Zahlungsdatum",
  "nearEndTimeMessage_info": "Hier wird eingestellt ob und wann eine Mail vor Ablauf einer Buchung an den Kunden gesendet wird. Bei Einstellung von 0 Sekunden wird keine Mail gesendet.",
  "time send mail before end": "Zeit vor Ende der Buchung für Benachrichtung an Kunden"
}